(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dialog-simple"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('dialog-simple')) {
      customElements.define(
        'dialog-simple',
        class DialogSimple extends HTMLElement {
          constructor() {
            super();
          }

          static get observedAttributes() {
            return ['data-show', 'data-title', 'data-desc', 'data-button-text', 'data-button-link', 'data-img'];
          }

          attributeChangedCallback(name, oldValue, newValue) {
            if (oldValue === newValue) return;

            switch (name) {
              case 'data-show':
                if (newValue === 'true') {
                  this.style.display = '';
                  // 禁用body滚动
                  window.redodo.disableScroll();
                } else {
                  this.style.display = 'none';
                  // 启用body滚动
                  window.redodo.enableScroll();
                }
                break;

              case 'data-title': {
                const titleEl = this.querySelector('.dialog-simple__title');
                if (titleEl) titleEl.textContent = newValue || '';
                break;
              }

              case 'data-desc': {
                const descEl = this.querySelector('.dialog-simple__desc');
                if (descEl) descEl.innerHTML = newValue || '';
                break;
              }

              case 'data-button-text': {
                const btnEl = this.querySelector('.dialog-simple__button a');
                if (btnEl) btnEl.textContent = newValue || '';
                break;
              }

              case 'data-button-link': {
                const buttonContainer = this.querySelector('.dialog-simple__button');
                const buttonEl = buttonContainer?.querySelector('a');
                if (newValue && buttonEl) {
                  buttonEl.setAttribute('href', newValue);
                  buttonContainer.style.display = '';
                } else if (buttonContainer) {
                  buttonContainer.style.display = 'none';
                }
                break;
              }

              case 'data-img': {
                const imgEl = this.querySelector('.dialog-simple__img');
                if (newValue && imgEl) {
                  imgEl.setAttribute('src', newValue);
                  imgEl.style.display = '';
                } else if (imgEl) {
                  imgEl.style.display = 'none';
                }
                break;
              }
            }
          }

          connectedCallback() {
            const closeBtn = this.querySelector('.dialog-simple__close');
            if (closeBtn) {
              closeBtn.addEventListener('click', () => {
                this.setAttribute('data-show', 'false');
              });
            }
            this._initializeContent();
          }

          _initializeContent() {
            const title = this.getAttribute('data-title');
            const desc = this.getAttribute('data-desc');
            const buttonText = this.getAttribute('data-button-text');
            const buttonLink = this.getAttribute('data-button-link');
            const img = this.getAttribute('data-img');

            const titleEl = this.querySelector('.dialog-simple__title');
            if (titleEl) titleEl.textContent = title || '';

            const descEl = this.querySelector('.dialog-simple__desc');
            if (desc && descEl) descEl.innerHTML = desc;

            const btnEl = this.querySelector('.dialog-simple__button a');
            const btnContainer = this.querySelector('.dialog-simple__button');
            if (buttonText && btnEl) btnEl.textContent = buttonText;
            if (buttonLink && btnEl && btnContainer) {
              btnEl.setAttribute('href', buttonLink);
              btnContainer.style.display = '';
            } else if (btnContainer) {
              btnContainer.style.display = 'none';
            }

            const imgEl = this.querySelector('.dialog-simple__img');
            if (img && imgEl) {
              imgEl.setAttribute('src', img);
              imgEl.style.display = '';
            } else if (imgEl) {
              imgEl.style.display = 'none';
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dialog-subscribe"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('dialog-subscribe')) {
      customElements.define(
        'dialog-subscribe',
        class DialogSimple extends HTMLElement {
          constructor() {
            super();
            this.dialog = null;
            this.productId = null;
            this.variantId = null;
            this.email = null;
            this.companyId = 'WViBvu';
            this.listId = 'XVbpHP';
            this.backInStockUrl = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
            this.listUrl = 'https://a.klaviyo.com/client/subscriptions/';

            // 绑定事件函数，确保 removeEventListener 生效
            this.handleWrapperClick = this.handleWrapperClick.bind(this);
            this.handleSubscribeClick = this.handleSubscribeClick.bind(this);
          }

          connectedCallback() {
            this.dialog = this;
            this.init();
            this.setupMutationObserver();
            this.closeDialog();
          }

          closeDialog() {
            const closeButtons = this.dialog.querySelectorAll('.dialog-close');
            const dialog = this.dialog;

            closeButtons.forEach(function (closeButton) {
              closeButton.addEventListener('click', function () {
                dialog.classList.add('hidden');
                if (window.enableScroll) {
                  window.enableScroll();
                }
              });
            });
          }

          klaviyoBisWrapperClick() {
            const wrappers = document.querySelectorAll('.klaviyo-bis-wrapper');
            const self = this;

            wrappers.forEach(function (wrapper) {
              wrapper.addEventListener('click', self.handleWrapperClick);
            });
          }

          handleWrapperClick(event) {
            const wrapper = event.currentTarget;

            if (window.disableScroll) {
              window.disableScroll();
            }

            const checkbox = this.querySelector('#subscribeCheckbox');
            if (checkbox) checkbox.checked = true;

            this.productId = wrapper.getAttribute('data-product');
            this.variantId = wrapper.getAttribute('data-variant');
            this.productTitle = wrapper.getAttribute('data-product-title');

            document.querySelector('.dialog-subscribe').classList.remove('hidden');
          }

          agreeCheckboxFunction(id) {
            const checked = this.querySelector(id);
            return checked && checked.checked;
          }

          submitSubscribe() {
            const subscribeBtn = this.querySelector('.subscribe-btn');
            if (subscribeBtn) {
              subscribeBtn.addEventListener('click', this.handleSubscribeClick);
            }
            
          }

          handleSubscribeClick() {
            const checkboxShow = this.agreeCheckboxFunction('#subscribeCheckbox');
            const inputDom = this.querySelector('.input_text');
            const inputTextContainer = inputDom ? inputDom.closest('.input_text_container') : null;

            if (!inputDom || !inputTextContainer) return;

            const inputText = inputDom.value;
            const rule = inputTextContainer.dataset.rule;

            if (rule && rule === 'email') {
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

              if (emailRegex.test(inputText)) {
                this.email = inputText;

                if (this.productId && this.variantId && this.email && this.productTitle) {
                  const rotateIcon = this.querySelector('.rotate_icon');
                  const loadingText = this.querySelector('.loading-button-text');
                  console.log(11, rotateIcon, loadingText);

                  if (rotateIcon) {
                    rotateIcon.classList.add('flex');
                    rotateIcon.classList.remove('hidden');
                  }
                  if (loadingText) {
                    loadingText.classList.add('hidden');
                    loadingText.classList.remove('flex');
                  }

                  this.fetchSubscribe(
                    this.productId,
                    this.variantId,
                    this.email,
                    this.productTitle,
                    checkboxShow,
                    rotateIcon,
                    loadingText
                  );
                }
              } else {
                inputTextContainer.setAttribute('data-error', 'true');
              }
            }
          }

          async fetchSubscribe(productId, variantId, email, productTitle, checkboxShow, rotateIcon, loadingText) {
            const modifiedTimestamp = this.modifyTimestamp(new Date().getTime());
            const headers_subscribe = {
              'Content-Type': 'application/json',
              nonce: this.getAttribute('data-nonce'),
              ticket: this.getAttribute('data-ticket'),
              timestamp: modifiedTimestamp,
              shop: window.Shopify.shop,
            };

            // 将productTitle中的逗号转义成空格
            const newProductTitle = productTitle.replace(/,/g, ' ');
            const body = {
              email: email,
              tag: '到货订阅,' + newProductTitle + '',
              acceptsMarketing: checkboxShow ? 1 : 0,
            };

            let baseUrl = '';
            if (window.base_info && window.base_info.url == 'dev-askstarry.myshopify.com') {
              baseUrl = 'https://dev-api.askstarry.com';
            } else {
              baseUrl = 'https://api.askstarry.com';
            }

            try {
              const response = await fetch(baseUrl + '/business-api/shopify/subscribe/email', {
                method: 'POST',
                headers: headers_subscribe,
                body: JSON.stringify(body),
              });

              if (response.status != 200) {
                if (rotateIcon) {
                  rotateIcon.classList.add('hidden');
                  rotateIcon.classList.remove('flex');
                }
                if (loadingText) {
                  loadingText.classList.add('flex');
                  loadingText.classList.remove('hidden');
                }

                if (window.redodo && window.redodo.showToast) {
                  window.redodo.showToast('error', 'Failed to subscribe', 2000);
                }

                if (window.redodo && window.redodo.enableScroll) {
                  window.redodo.enableScroll();
                }

                this.classList.add('hidden');
                return;
              }

              const data = await response.json();

              const successText =
                this.getAttribute('data-success-text') || 'Back In Stock Reminder Subscribe Successfully';

              if (window.redodo && window.redodo.showToast) {
                window.redodo.showToast('success', successText, 2000);
              }

              this.classList.add('hidden');
              console.log(22, rotateIcon, loadingText);

              if (rotateIcon) {
                console.log(55);
                rotateIcon.classList.add('hidden');
                rotateIcon.classList.remove('flex');
              }
              if (loadingText) {
                console.log(33);
                loadingText.classList.add('flex');
                loadingText.classList.remove('hidden');
              }

              if (window.enableScroll) {
                window.enableScroll();
              }
            } catch (error) {
              console.error('请求失败:', error);
              if (rotateIcon) {
                rotateIcon.classList.add('hidden');
                rotateIcon.classList.remove('flex');
              }
              if (loadingText) {
                loadingText.classList.add('flex');
                loadingText.classList.remove('hidden');
              }

              if (window.redodo && window.redodo.showToast) {
                window.redodo.showToast('error', 'Failed to subscribe', 2000);
              }
            }

            // Klaviyo API 调用
            const customVariantId = '$shopify:::$default:::' + variantId;
            const backInStockData = {
              data: {
                type: 'back-in-stock-subscription',
                attributes: {
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: { email: email },
                    },
                  },
                  channels: ['EMAIL'],
                },
                relationships: {
                  variant: {
                    data: {
                      type: 'catalog-variant',
                      id: customVariantId,
                    },
                  },
                },
              },
            };

            const listSubscriptionData = {
              data: {
                type: 'subscription',
                attributes: {
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: email,
                        properties: {
                          $source: 'Back in Stock',
                        },
                      },
                    },
                  },
                },
                relationships: {
                  list: {
                    data: {
                      type: 'list',
                      id: this.listId,
                    },
                  },
                },
              },
            };

            const headers = {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              REVISION: '2024-02-15',
            };

            // 前两个请求静默处理
            Promise.allSettled([
              fetch(this.backInStockUrl + '?company_id=' + this.companyId, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(backInStockData),
              }),
              fetch(this.listUrl + '?company_id=' + this.companyId, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(listSubscriptionData),
              }),
            ]).catch(function () {
              console.log('第三方接口请求失败');
            });
          }

          // 移除事件监听器
          removeEventListeners() {
            const elements = document.querySelectorAll('.klaviyo-bis-wrapper');
            const self = this;

            elements.forEach(function (element) {
              element.removeEventListener('click', self.handleWrapperClick);
            });

            const subscribeBtn = this.querySelector('.subscribe-btn');
            if (subscribeBtn) {
              subscribeBtn.removeEventListener('click', this.handleSubscribeClick);
            }
          }

          modifyTimestamp(timestamp, mod = 10) {
            const str = timestamp.toString();
            const first12 = str.slice(0, 12);
            const sum = [...first12].reduce((acc, digit) => acc + Number(digit), 0);
            const replacement = sum % mod;
            return Number(first12 + replacement);
          }

          // 初始化
          init() {
            this.removeEventListeners();
            this.klaviyoBisWrapperClick();
            this.submitSubscribe();
          }

          // 设置观察者
          setupMutationObserver() {
            var self = this;
            var observer = new MutationObserver(function (mutations) {
              mutations.forEach(function (mutation) {
                if (mutation.type === 'childList') {
                  self.init();
                }
              });
            });

            observer.observe(document.body, {
              childList: true,
              subtree: true,
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-button-icon"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('global-button-icon')) {
      customElements.define(
        'global-button-icon',
        class GlobalButtonIcon extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            this.init();
          }

          init() {
            this.setupHoverReset();
          }

          setupHoverReset() {
            const button = this.querySelector('.global-button-icon__button');
            if (!button) return;

            let resetTimer = null;

            // 检查屏幕宽度是否大于1200px
            const isDesktop = () => window.innerWidth > 1200;

            // 定义事件处理函数
            const handleMouseEnter = () => {
              // 1200px以下不触发hover效果
              if (!isDesktop()) return;

              // 清除计时器
              if (resetTimer) {
                clearTimeout(resetTimer);
                resetTimer = null;
              }

              // 移入时：移动到居中位置
              button.style.setProperty('--pseudo-transform-y', '-25%');
            };

            const handleMouseLeave = () => {
              // 1200px以下不触发hover效果
              if (!isDesktop()) return;

              // 清除计时器
              if (resetTimer) {
                clearTimeout(resetTimer);
                resetTimer = null;
              }

              // 移出时：继续往上移动到按钮上方
              button.style.setProperty('--pseudo-transform-y', '-100%');

              // 动画结束后重置到初始位置
              const transitionTime =
                getComputedStyle(button).getPropertyValue('--global-button-icon-hover-transition-time') || '0.6s';
              const delayTime = parseFloat(transitionTime) * 1000; // 转换为毫秒

              resetTimer = setTimeout(() => {
                // 临时移除transition，避免重置时的动画效果
                button.style.setProperty('--pseudo-transition', 'none');
                // 重置位置
                button.style.setProperty('--pseudo-transform-y', '100%');

                // 短暂延迟后恢复transition
                setTimeout(() => {
                  button.style.setProperty('--pseudo-transition', `all ${transitionTime} ease`);
                  resetTimer = null;
                }, 50);
              }, delayTime); // 等待CSS transition完成
            };

            const handleResize = () => {
              if (!isDesktop()) {
                // 如果切换到移动端，重置所有状态
                if (resetTimer) {
                  clearTimeout(resetTimer);
                  resetTimer = null;
                }
                button.style.setProperty('--pseudo-transform-y', '100%');
                button.style.setProperty(
                  '--pseudo-transition',
                  'all var(--global-button-icon-hover-transition-time, 0.6s) ease'
                );
              }
            };

            // 添加事件监听器
            button.addEventListener('mouseenter', handleMouseEnter);
            button.addEventListener('mouseleave', handleMouseLeave);
            window.addEventListener('resize', handleResize);

            // 保存事件处理函数引用，用于卸载
            this._handleMouseEnter = handleMouseEnter;
            this._handleMouseLeave = handleMouseLeave;
            this._handleResize = handleResize;
            this._resetTimer = resetTimer;
          }

          disconnectedCallback() {
            // 清理所有事件监听器和计时器
            const button = this.querySelector('.global-button-icon__button');

            if (button) {
              // 移除事件监听器
              if (this._handleMouseEnter) {
                button.removeEventListener('mouseenter', this._handleMouseEnter);
              }
              if (this._handleMouseLeave) {
                button.removeEventListener('mouseleave', this._handleMouseLeave);
              }
            }

            // 移除窗口事件监听器
            if (this._handleResize) {
              window.removeEventListener('resize', this._handleResize);
            }

            // 清除计时器
            if (this._resetTimer) {
              clearTimeout(this._resetTimer);
            }

            // 清理引用
            this._handleMouseEnter = null;
            this._handleMouseLeave = null;
            this._handleResize = null;
            this._resetTimer = null;
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('global-button')) {
      customElements.define(
        'global-button',
        class GlobalButton extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            this.init();
            // this.testEvent();
          }

          init() {
            this.detectButtonType();
            this.setupHoverReset();
          }

          detectButtonType() {
            const button = this.querySelector('.global-button__button');
            if (!button) return;

            const defaultBgColor = getComputedStyle(this).getPropertyValue('--global-button-default-bg-color').trim();
            const defaultBorderColor = getComputedStyle(this).getPropertyValue('--global-button-default-border-color').trim();
            
            // 判断是否有背景颜色（不是 transparent 且不是空）
            const hasBackground = defaultBgColor && 
                                 defaultBgColor !== 'transparent' && 
                                 defaultBgColor !== 'rgba(0, 0, 0, 0)' &&
                                 defaultBgColor !== '';
            
            // 判断是否只有边框（背景是 transparent 但有边框）
            const hasBorderOnly = (!defaultBgColor || 
                                   defaultBgColor === 'transparent' || 
                                   defaultBgColor === 'rgba(0, 0, 0, 0)') &&
                                  defaultBorderColor && 
                                  defaultBorderColor !== 'transparent' &&
                                  defaultBorderColor !== 'rgba(0, 0, 0, 0)' &&
                                  defaultBorderColor !== '';

            if (hasBackground) {
              button.setAttribute('data-has-bg', 'true');
            } else if (hasBorderOnly) {
              button.setAttribute('data-has-border-only', 'true');
            }
          }

          setupHoverReset() {
            const button = this.querySelector('.global-button__button');
            if (!button) return;

            let resetTimer = null;

            // 检查屏幕宽度是否大于1200px
            const isDesktop = () => window.innerWidth > 1200;

            // 定义事件处理函数
            const handleMouseEnter = () => {
              // 1200px以下不触发hover效果
              if (!isDesktop()) return;

              // 清除计时器
              if (resetTimer) {
                clearTimeout(resetTimer);
                resetTimer = null;
              }

              // 移入时：移动到居中位置
              button.style.setProperty('--pseudo-transform-y', '-25%');
            };

            const handleMouseLeave = () => {
              // 1200px以下不触发hover效果
              if (!isDesktop()) return;

              // 清除计时器
              if (resetTimer) {
                clearTimeout(resetTimer);
                resetTimer = null;
              }

              // 移出时：继续往上移动到按钮上方
              button.style.setProperty('--pseudo-transform-y', '-100%');

              // 动画结束后重置到初始位置
              const transitionTime =
                getComputedStyle(button).getPropertyValue('--global-button-hover-transition-time') || '0.6s';
              const delayTime = parseFloat(transitionTime) * 1000; // 转换为毫秒

              resetTimer = setTimeout(() => {
                // 临时移除transition，避免重置时的动画效果
                button.style.setProperty('--pseudo-transition', 'none');
                // 重置位置
                button.style.setProperty('--pseudo-transform-y', '100%');

                // 短暂延迟后恢复transition
                setTimeout(() => {
                  button.style.setProperty('--pseudo-transition', `all ${transitionTime} ease`);
                  resetTimer = null;
                }, 50);
              }, delayTime); // 等待CSS transition完成
            };

            const handleResize = () => {
              if (!isDesktop()) {
                // 如果切换到移动端，重置所有状态
                if (resetTimer) {
                  clearTimeout(resetTimer);
                  resetTimer = null;
                }
                button.style.setProperty('--pseudo-transform-y', '100%');
                button.style.setProperty(
                  '--pseudo-transition',
                  'all var(--global-button-hover-transition-time, 0.6s) ease'
                );
              }
            };

            // 添加事件监听器
            button.addEventListener('mouseenter', handleMouseEnter);
            button.addEventListener('mouseleave', handleMouseLeave);
            window.addEventListener('resize', handleResize);

            // 保存事件处理函数引用，用于卸载
            this._handleMouseEnter = handleMouseEnter;
            this._handleMouseLeave = handleMouseLeave;
            this._handleResize = handleResize;
            this._resetTimer = resetTimer;
          }
          testEvent() {
            const button = this.querySelector('.global-button__button');
            if (!button) return;

            const handleClick = () => {
              if (button.getAttribute('data-loading') === 'true') return;
              if (button.getAttribute('data-disabled') === 'true') return;
              button.setAttribute('data-loading', 'true');
              setTimeout(() => {
                button.setAttribute('data-loading', 'false');
              }, 3000);
            };

            button.addEventListener('click', handleClick);
          }

          disconnectedCallback() {
            // 清理所有事件监听器和计时器
            const button = this.querySelector('.global-button__button');

            if (button) {
              // 移除事件监听器
              if (this._handleMouseEnter) {
                button.removeEventListener('mouseenter', this._handleMouseEnter);
              }
              if (this._handleMouseLeave) {
                button.removeEventListener('mouseleave', this._handleMouseLeave);
              }
            }

            // 移除窗口事件监听器
            if (this._handleResize) {
              window.removeEventListener('resize', this._handleResize);
            }

            // 清除计时器
            if (this._resetTimer) {
              clearTimeout(this._resetTimer);
            }

            // 清理引用
            this._handleMouseEnter = null;
            this._handleMouseLeave = null;
            this._handleResize = null;
            this._resetTimer = null;
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-discount"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('global-discount')) {
      class GlobalDiscount extends HTMLElement {
        constructor() {
          super();
          this.shopMoneyFormat = window.shopMoneyFormat;
        }

        static get observedAttributes() {
          return ['data-total', 'data-price', 'data-type'];
        }

        attributeChangedCallback(name, oldValue, newValue) {
          if (oldValue === newValue) return;
          switch (name) {
            case 'data-total':
              this.total = JSON.parse(newValue);
              this.price = parseFloat(this.total.price);
              this.comparePrice = parseFloat(this.total.compare_price);
              this.updatePrice();
              break;
          }
        }

        connectedCallback() {
          this.type = this.getAttribute('data-type');
        }

        updatePrice() {
          let computeShowEl = document.querySelector('.compute-show');

          if (this.price > 0 && this.comparePrice > 0) {
            if (this.type === 'quota') {
              this.discount = this.comparePrice - this.price;
              this.discountFormat = window.Shopify.formatMoney(this.discount, this.shopMoneyFormat);

              // 将折扣值转换为整数后比较
              if (parseInt(this.discount) > 0) {
                if (computeShowEl) {
                  computeShowEl.classList.remove('hidden');
                }

                const discountContainer = document.querySelector('.actual_discount-total-container');
                if (discountContainer) {
                  discountContainer.classList.remove('hidden');
                }

                const quotaDiscount = document.querySelector('.compute-show .quota-discount');
                if (quotaDiscount) {
                  quotaDiscount.innerHTML = this.discountFormat;
                }
              } else {
                if (computeShowEl) {
                  computeShowEl.classList.add('hidden');
                }

                const discountContainer = document.querySelector('.actual_discount-total-container');
                if (discountContainer) {
                  discountContainer.classList.add('hidden');
                }
              }
            } else if (this.type === 'percentage') {
              this.discount = ((this.comparePrice - this.price) / this.comparePrice) * 100;
              this.discount = Math.floor(this.discount);

              // 将折扣值转换为整数后比较
              if (parseInt(this.discount) > 0) {
                if (computeShowEl) {
                  computeShowEl.classList.remove('hidden');
                }

                const discountContainer = document.querySelector('.actual_discount-total-container');
                if (discountContainer) {
                  discountContainer.classList.remove('hidden');
                }

                const scaleDiscount = document.querySelector('.compute-show .scale-discount');
                if (scaleDiscount) {
                  scaleDiscount.innerHTML = this.discount;
                }
              } else {
                if (computeShowEl) {
                  computeShowEl.classList.add('hidden');
                }

                const discountContainer = document.querySelector('.actual_discount-total-container');
                if (discountContainer) {
                  discountContainer.classList.add('hidden');
                }
              }
            }
          }
        }
      }

      customElements.define('global-discount', GlobalDiscount);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('global-product')) {
      // 创建弹窗根容器
      const createModalRoot = () => {
        const existingRoot = document.getElementById('global-modal__root');
        if (existingRoot) return existingRoot;

        const root = document.createElement('div');
        root.id = 'global-modal__root';
        root.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 500;
      `;
        document.body.appendChild(root);
        return root;
      };

      class GlobalProduct extends HTMLElement {
        constructor() {
          super();
          this.shopMoneyFormat = null;
          this.productDetailModal = null;
          this.mobileClickStatus = false;
          this.checkoutLoading = false;
        }

        // 获取或创建根容器
        static getRoot() {
          if (!this.root) {
            this.root = createModalRoot();
          }
          return this.root;
        }

        connectedCallback() {
          const _this = this;

          window.addEventListener('pagehide', (event) => {
            this.checkoutLoading = false;
            const rotateIcon = this.querySelector('.buy-now-btn-card-button-popup .rotate_icon');
            if (rotateIcon) {
              rotateIcon.classList.remove('flex');
              rotateIcon.classList.add('hidden');
            }
          });

          this.init();

          const functionIconWrappers = this.querySelectorAll('.function_icon_wrapper');
          const functionTextWrappers = this.querySelectorAll('.function_text_wrapper');
          const functionIcons = this.querySelectorAll('.function_icon');

          const clearClickStatus = () => {
            this.mobileClickStatus = false;
            functionTextWrappers.forEach((wrapper) => {
              wrapper.style.opacity = '0';
              wrapper.style.top = '0';
            });

            functionIconWrappers.forEach((wrapper) => {
              wrapper.setAttribute('data-click-status', 'false');
            });

            functionIcons.forEach((icon) => {
              icon.classList.remove('hover_icon');
            });
          };

          functionIconWrappers.forEach((wrapper) => {
            wrapper.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();

              if (window.innerWidth <= 1200) {
                _this.mobileClickStatus = true;
                if (this.getAttribute('data-click-status') === 'false') {
                  functionTextWrappers.forEach((textWrapper) => {
                    textWrapper.style.opacity = '0';
                    textWrapper.style.top = '0';
                  });

                  functionIcons.forEach((icon) => {
                    icon.classList.remove('hover_icon');
                  });

                  functionIconWrappers.forEach((iconWrapper) => {
                    iconWrapper.setAttribute('data-click-status', 'false');
                  });

                  this.setAttribute('data-click-status', 'true');
                  this.querySelector('.function_icon').classList.add('hover_icon');

                  const textWrapper = this.querySelector('.function_text_wrapper');
                  textWrapper.classList.add('block');
                  textWrapper.classList.remove('hidden');
                  textWrapper.style.opacity = '1';
                  textWrapper.style.top = '-12px';
                } else {
                  clearClickStatus();
                }
              }
            });
          });

          document.addEventListener('click', (e) => {
            if (this.mobileClickStatus) {
              clearClickStatus();
            }
          });
        }

        init() {
          const _this = this;

          this.shopMoneyFormat = window.shopMoneyFormat;

          // 获取所有data-product-handle的元素
          const productHandles = this.querySelectorAll('[data-product-handle]');

          productHandles.forEach((handle) => {
            handle.addEventListener('click', function (event) {
              return;

              event.preventDefault();
              _this.openProductDetailModal(this);
            });
          });

          this.addToCartEvent();
          this.addNotifyMeEvent();

          const functionTagsContainers = this.querySelectorAll('.global-product__function_wrapper');
          this.tagFunctionScroll(functionTagsContainers);
        }

        addToCartEvent() {
          const addToCartButtons = this.querySelectorAll('[data-first_variant_id]');

          if (!addToCartButtons.length) return;

          addToCartButtons.forEach((addToCart) => {
            // 获取容器上的数据属性
            const container = addToCart.closest('[data-first_variant_id]');
            const variantId = container.dataset['first_variant_id'];
            const currentNum = container.dataset['sku_count'];

            addToCart.addEventListener('click', async (event) => {
              event.preventDefault();
              const button = addToCart.querySelector('.global-button__button');

              button.setAttribute('data-loading', 'true');

              try {
                const response = await window.redodo.addCart([{ id: variantId, quantity: 1 }]);
              } catch (error) {
                console.error('Error:', error);
              } finally {
                button.setAttribute('data-loading', 'false');
              }
            });
          });
        }

        addNotifyMeEvent() {
          const notifyMe = this.querySelector('.global-product__notify_btn');
          if (!notifyMe) return;
          notifyMe.addEventListener('click', () => {
            const notifyModal = document.querySelector('global-stock-notify-modal');
            const stickyForm = document.querySelector('ro-product-sticky-form');
            const variantId = notifyMe.dataset.variantId;
            if (variantId && notifyModal) {
              notifyModal.open(variantId);
            }
          });
        }

        tagFunctionScroll(elementList, initSpeed = 10, InitReturnSpeed = 3) {
          let speed = initSpeed * 1000;
          let returnSpeed = InitReturnSpeed * 1000;
          if (!elementList.length) return;

          // 检测屏幕宽度，1200px及以下不触发
          if (window.innerWidth <= 1200) return;

          // 存储每个容器的原始滚动位置和动画帧ID
          const originalScrollPositions = new Map();
          const animationFrameIds = new Map();

          // 自定义平滑滚动函数 - 固定时间移动相同距离
          const smoothScroll = (element, target, duration) => {
            // 先取消之前的动画
            if (animationFrameIds.has(element)) {
              cancelAnimationFrame(animationFrameIds.get(element));
            }

            const start = element.scrollLeft;
            const distance = target - start;
            const startTime = performance.now();

            function animateScroll(currentTime) {
              const elapsed = currentTime - startTime;

              if (elapsed < duration) {
                // 固定速度滚动
                const progress = elapsed / duration;
                element.scrollLeft = start + distance * progress;
                const frameId = requestAnimationFrame(animateScroll);
                animationFrameIds.set(element, frameId);
              } else {
                // 确保最终位置准确
                element.scrollLeft = target;
                animationFrameIds.delete(element);
              }
            }

            const frameId = requestAnimationFrame(animateScroll);
            animationFrameIds.set(element, frameId);
          };

          // 为每个容器添加事件监听
          elementList.forEach((container) => {
            originalScrollPositions.set(container, container.scrollLeft);

            // 使用防抖包装事件处理函数
            const debouncedMouseEnter = window.redodo.debounce(function () {
              const targetScroll = container.scrollWidth - container.clientWidth;

              if (speed === 0) {
                container.scrollLeft = targetScroll;
              } else {
                // 计算实际需要的滚动时间（基于距离）
                const distance = targetScroll - container.scrollLeft;
                const actualDuration = Math.abs(distance) * (speed / 1000);
                smoothScroll(container, targetScroll, actualDuration);
              }
            }, 50); // 50ms防抖延迟

            const debouncedMouseLeave = window.redodo.debounce(function () {
              const originalScrollLeft = originalScrollPositions.get(container);

              if (returnSpeed === 0) {
                container.scrollLeft = originalScrollLeft;
              } else {
                // 使用更快的速度返回
                const distance = originalScrollLeft - container.scrollLeft;
                const actualDuration = Math.abs(distance) * (returnSpeed / 1000);
                smoothScroll(container, originalScrollLeft, actualDuration);
              }
            }, 50); // 50ms防抖延迟

            // 存储处理函数以便后续移除
            container._mouseEnterHandler = debouncedMouseEnter;
            container._mouseLeaveHandler = debouncedMouseLeave;

            container.addEventListener('mouseenter', debouncedMouseEnter);
            container.addEventListener('mouseleave', debouncedMouseLeave);
          });

          // 添加窗口resize监听
          const handleResize = () => {
            if (window.innerWidth <= 1200) {
              this.clearListeners.call(this);
            }
          };

          window.addEventListener('resize', handleResize);
          this._resizeHandler = handleResize;
        }

        // 清除监听
        clearListeners() {
          const functionTagsContainers = this.querySelectorAll('.collection-hot-products__product_function_tags');

          functionTagsContainers.forEach((container) => {
            if (container._mouseEnterHandler) {
              container.removeEventListener('mouseenter', container._mouseEnterHandler);
              delete container._mouseEnterHandler;
            }

            if (container._mouseLeaveHandler) {
              container.removeEventListener('mouseleave', container._mouseLeaveHandler);
              delete container._mouseLeaveHandler;
            }
          });

          if (this._resizeHandler) {
            window.removeEventListener('resize', this._resizeHandler);
            delete this._resizeHandler;
          }
        }

        openProductDetailModal(element, inventoryPolicy, view) {
          const _this = this;
          window.disableScroll();
          window.redodo.showLoading(false);

          const productHandle = element.dataset.productHandle;

          fetch(`/products/${productHandle}?view=modal`)
            .then((response) => {
              if (response.status === 200) {
                return response.text();
              } else {
                throw new Error('Network response was not ok');
              }
            })
            .then((responseText) => {
              _this.renderProductDetailModal(responseText, inventoryPolicy, view);
            })
            .finally(() => {
              window.litime.hideLoading(false);
            });
        }

        renderProductDetailModal(html, inventoryPolicy, view) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const quickshopPopup = doc.getElementById('quickshop-popup');

          if (quickshopPopup) {
            const productDetailModal = document.getElementById('global-product-card-popup');
            if (productDetailModal) {
              productDetailModal.innerHTML = quickshopPopup.innerHTML;

              const modalWrapper = productDetailModal.querySelector('.product-detail-modal_wrapper');
              if (modalWrapper) {
                if (inventoryPolicy === 'continue' && view === 'buy_now_to_cart') {
                  const preOrderButton = modalWrapper.querySelector(
                    '.product-detail-popup_button .buy-now-btn-card-button-popup'
                  );
                  if (preOrderButton) {
                    preOrderButton.classList.remove('hidden');
                    preOrderButton.classList.add('flex');
                  }

                  const preOrderSubmitButton = modalWrapper.querySelector(
                    '.product-detail-popup_form_wrapper .buy-now-btn-card-submit-button'
                  );
                  if (preOrderSubmitButton) {
                    preOrderSubmitButton.classList.add('hidden');
                    preOrderSubmitButton.classList.remove('flex');
                  }
                } else {
                  const preOrderButton = modalWrapper.querySelector(
                    '.product-detail-popup_form_wrapper .buy-now-btn-card-button-popup'
                  );
                  if (preOrderButton) {
                    preOrderButton.classList.add('hidden');
                    preOrderButton.classList.remove('flex');
                  }

                  const preOrderSubmitButton = modalWrapper.querySelector(
                    '.product-detail-popup_form_wrapper .buy-now-btn-card-submit-button'
                  );
                  if (preOrderSubmitButton) {
                    preOrderSubmitButton.classList.remove('hidden');
                    preOrderSubmitButton.classList.add('flex');
                  }
                }
              }
            }
          }
        }

        destroy() {
          // 恢复浏览器滚动
          window.enableScroll();

          if (this.productDetailModalSmallPictrueSwiper) {
            this.productDetailModalSmallPictrueSwiper.destroy();
          }
          if (this.productDetailModalBigPictrueSwiper) {
            this.productDetailModalBigPictrueSwiper.destroy();
          }

          // 移除时同时清理弹窗
          if (this.productDetailModal) {
            this.productDetailModal.remove();
            this.productDetailModal = null;
          }
        }

        disconnectedCallback() {
          this.destroy();
        }
      }

      customElements.define('global-product', GlobalProduct);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-stock-notify-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('global-stock-notify-modal')) {
      customElements.define(
        'global-stock-notify-modal',
        class GlobalStockNotifyModal extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.closeBtnEle = this.querySelector('.global-stock-notify-modal__content_close_btn');
            this.closeBtnEle.addEventListener('click', () => this.close());
            this.buttonEle = this.querySelector('.global-stock-notify-modal__content_button');
            this.buttonEle.addEventListener('click', (e) => this.handleSubmit(e));
            this.checkboxEle = this.querySelector('.global-stock-notify-modal__content_checkbox');
            this.checkboxEle.addEventListener('click', () => this.handleCheckbox());
          }
          open(variantId) {
            if (!variantId) {
              console.error('variantId is required');
              return;
            }
            const waitlistTag = `waitlist_${variantId}`;
            this.setAttribute('data-tag', waitlistTag);
            window.disableScroll();
            this.setAttribute('data-is-open', 'true');
          }
          close() {
            this.setAttribute('data-is-open', 'false');
            const waitlistTag = this.querySelector('.global-stock-notify-modal__content_waitlist_tag');
            if (waitlistTag) {
              waitlistTag.value = '';
            }
            const emailInput = this.querySelector('.global-stock-notify-modal__content_input');
            if (emailInput) {
              emailInput.value = '';
            }
            const errorEle = this.querySelector('.global-stock-notify-modal__content_input_error');
            if (errorEle) {
              errorEle.style.display = 'none';
            }
            window.enableScroll();
          }
          handleCheckbox() {
            if (this.getAttribute('data-checkbox') === 'true') {
              this.setAttribute('data-checkbox', 'false');
            } else {
              this.setAttribute('data-checkbox', 'true');
            }
          }
          modifyTimestamp(timestamp, mod = 10) {
            const str = timestamp.toString();
            const first12 = str.slice(0, 12);
            const sum = [...first12].reduce((acc, digit) => acc + Number(digit), 0);
            const replacement = sum % mod;
            return Number(first12 + replacement);
          }
          handleSubmit(e) {
            // 阻止默认行为
            e.preventDefault();
            if (this.buttonEle.getAttribute('data-loading') === 'true') return;
            const emailInput = this.querySelector('.global-stock-notify-modal__content_input');
            const errorEle = this.querySelector('.global-stock-notify-modal__content_input_error');
            // 非空检验
            if (emailInput) {
              if (!emailInput.value) {
                errorEle.textContent = this.getAttribute('data-required-text');
                errorEle.style.display = 'block';
                return;
              }
              // 验证邮箱格式
              const emailRegexp = /^[^@\s]+@[^.@\s]+\.[^@\s]+$/;
              if (!emailRegexp.test(emailInput.value)) {
                errorEle.textContent = this.getAttribute('data-invalid-text');
                errorEle.style.display = 'block';
                return;
              }
            }
            errorEle.style.display = 'none';
            const modifiedTimestamp = this.modifyTimestamp(new Date().getTime());
            const params = {
              tag: this.getAttribute('data-tag'),
              email: emailInput.value,
              acceptsMarketing: this.getAttribute('data-checkbox') == 'true' ? 1 : 0,
            };
            let baseUrl = '';
            if (window.Shopify.shop == 'dev-askstarry.myshopify.com') {
              baseUrl = 'https://dev-api.askstarry.com';
            } else {
              baseUrl = 'https://api.askstarry.com';
            }
            const headersSubscribe = {
              'Content-Type': 'application/json',
              shop: window.Shopify.shop,
              timestamp: modifiedTimestamp,
              nonce: this.getAttribute('data-nonce'),
              ticket: this.getAttribute('data-ticket'),
            };
            this.buttonEle.setAttribute('data-loading', 'true');
            fetch(baseUrl + '/business-api/shopify/subscribe/email', {
              method: 'POST',
              headers: headersSubscribe,
              body: JSON.stringify(params),
            })
              .then((response) => response.json())
              .then((response) => {
                console.log('response', response);
                if (response.code && response.code !== 200) {
                  window.redodo.showToast('error', response.message);
                  return;
                }
                const successText = this.getAttribute('data-success-text');
                window.redodo.showToast('success', successText);
                this.close();
              })
              .catch((error) => {
                console.error('Error:', error);
              })
              .finally(() => {
                this.buttonEle.setAttribute('data-loading', 'false');
              });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-toast"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('global-toast')) {
      customElements.define(
        'global-toast',
        class GlobalToast extends HTMLElement {
          constructor() {
            super();
            this.container = this.querySelector('.global-toast');
            this.template = this.querySelector('.global-toast__template');
            this.toasts = new Map();
            this.counter = 0;

            if (!window.redodo) window.redodo = {};
            window.redodo.showToast = this.showToast.bind(this);
          }

          connectedCallback() {
            this.init();
          }

          init() {}

          showToast(type, message, duration = 2000) {
            const id = `toast-${this.counter++}`;

            // 创建新的toast元素
            const newToast = this.createToast(id, type, message);
            this.container.appendChild(newToast);

            // 存储toast引用
            this.toasts.set(id, {
              element: newToast,
              timer: null,
            });

            // 显示动画
            requestAnimationFrame(() => {
              newToast.classList.add('show');
            });

            // 设置自动关闭定时器
            const timer = setTimeout(() => {
              this.removeToast(id);
            }, duration);

            // 更新计时器引用
            if (this.toasts.has(id)) {
              this.toasts.get(id).timer = timer;
            }

            return id; // 返回ID，可用于手动关闭
          }

          removeToast(id) {
            const toast = this.toasts.get(id);
            if (!toast) return;

            // 清除定时器
            if (toast.timer) {
              clearTimeout(toast.timer);
            }

            // 隐藏动画
            toast.element.classList.remove('show');
            toast.element.classList.add('hide');

            // 等待动画完成后移除元素
            setTimeout(() => {
              if (toast.element.parentNode) {
                toast.element.parentNode.removeChild(toast.element);
              }
              // 从Map中移除
              this.toasts.delete(id);
            }, 250); // 与CSS动画时长保持一致
          }

          createToast(id, type, message) {
            // 克隆模板
            const clone = this.template.content.cloneNode(true).firstElementChild;

            // 设置ID和数据属性
            clone.id = id;
            clone.dataset.type = type;

            // 设置消息内容
            clone.querySelector('.global-toast__message').innerHTML = message;

            // 设置图标和背景颜色
            const successIcon = clone.querySelector('.global-toast__icon-success');
            const warningIcon = clone.querySelector('.global-toast__icon-warning');
            const errorIcon = clone.querySelector('.global-toast__icon-error');

            let backgroundColor;
            let borderColor;
            switch (type) {
              case 'success':
                successIcon.classList.remove('hidden');
                backgroundColor = 'var(--toast-success-color)';
                borderColor = 'var(--toast-success-border-color)';
                break;
              case 'warning':
                warningIcon.classList.remove('hidden');
                backgroundColor = 'var(--toast-warning-color)';
                borderColor = 'var(--toast-warning-border-color)';
                break;
              case 'error':
                errorIcon.classList.remove('hidden');
                backgroundColor = 'var(--toast-error-color)';
                borderColor = 'var(--toast-error-border-color)';
                break;
            }

            clone.style.backgroundColor = backgroundColor;
            clone.style.borderColor = borderColor;

            return clone;
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["input-text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('input-text')) {
      customElements.define(
        'input-text',
        class InputText extends HTMLElement {
          constructor() {
            super();
            this.requiredText = '';
            this.formatText = '';
            this.rule = null;
          }

          connectedCallback() {
            this.init();
            const container = this.querySelector('.input_text_container');
            this.requiredText = container.dataset.tipEmpty || '';
            this.formatText = container.dataset.tipFormat || '';

            const ruleType = container.dataset.rule;
            switch (ruleType) {
              case 'email':
                this.rule = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // 简单的邮箱正则
                break;
              case 'password':
                this.rule = /^(?=.*[A-Za-z])(?=.*\d).{6,}$/; // 至少一个字母一个数字，最少6位
                break;
              case 'password_confirmation':
                this.rule = null; // 特殊处理，不需要正则
                break;
              default:
                this.rule = null;
            }
          }

          init() {
            const placeholderText = this.querySelector('.placeholder_text');
            const input = this.querySelector('input');

            this.addEventListener('click', () => {
              
              if (placeholderText) {
                placeholderText.style.top = '0.5rem';
                placeholderText.style.transform = 'translateY(0)';
              }
              this.focusInput();
              this.querySelector('.input_text_container').dataset.focus = 'true';
            });

            if (input) {
              input.addEventListener('change', () => {
                if (placeholderText) {
                  placeholderText.style.top = '0.5rem';
                  placeholderText.style.transform = 'translateY(0)';
                }
              });

              input.addEventListener('blur', this.blurInput.bind(this));

              // 初始化时检查是否有值
              if (input.value && placeholderText) {
                placeholderText.style.top = '0.5rem';
                placeholderText.style.transform = 'translateY(0)';
              }
            }
          }

          focusInput() {
            const input = this.querySelector('input');
            if (input) {
              input.focus();
            }
          }

          blurInput() {
            const container = this.querySelector('.input_text_container');
            container.dataset.focus = 'false';

            const input = this.querySelector('input');
            const value = input ? input.value : '';
            const required = input ? input.hasAttribute('required') : false;

            const errorMessage = this.querySelector('.error-message');

            if (!value) {
              const placeholderText = this.querySelector('.placeholder_text');
              if (placeholderText) {
                placeholderText.style.top = '50%';
                placeholderText.style.transform = 'translateY(-50%)';
              }

              if (required) {
                container.dataset.error = 'true';
                if (errorMessage) {
                  errorMessage.textContent = this.requiredText;
                  errorMessage.style.display = 'block';
                }
              }
            } else {
              if (this.rule) {
                if (this.rule.test(value)) {
                  container.dataset.error = 'false';
                  if (errorMessage) {
                    errorMessage.style.display = 'none';
                  }
                } else {
                  container.dataset.error = 'true';
                  if (errorMessage) {
                    errorMessage.textContent = this.formatText;
                    errorMessage.style.display = 'block';
                  }
                }
              } else {
                container.dataset.error = 'false';
                if (errorMessage) {
                  errorMessage.style.display = 'none';
                }
              }
            }

            // 密码确认特殊处理
            if (window.location.pathname.includes('/account/reset')) {
              const resetCustomer = document.querySelector('.reset_customer');
              if (resetCustomer) {
                const passwordInput = resetCustomer.querySelector('input[name="customer[password]"]');
                const passwordConfirmInput = resetCustomer.querySelector(
                  'input[name="customer[password_confirmation]"]'
                );

                if (passwordInput && passwordConfirmInput && passwordConfirmInput.value) {
                  const inputContainer = passwordConfirmInput.closest('.input_text_container');
                  const siblingErrorMessages = Array.from(inputContainer.parentNode.children).filter(
                    (child) => child !== inputContainer && child.classList.contains('error-message')
                  );

                  if (passwordInput.value !== passwordConfirmInput.value) {
                    inputContainer.dataset.error = 'true';
                    siblingErrorMessages.forEach((msg) => {
                      msg.textContent = window.i18n?.password_confirmation_different || '密码不一致';
                      msg.style.display = 'block';
                    });
                  } else {
                    inputContainer.dataset.error = 'false';
                    siblingErrorMessages.forEach((msg) => {
                      msg.style.display = 'none';
                    });
                  }
                }
              }
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-range"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('price-range')) {
      customElements.define(
        'price-range',
        class PriceRange extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            const rangeInput = this.querySelectorAll('.range-input input');
            const priceInput = this.querySelectorAll('.price-input input');
            const progress = this.querySelector('.slider .progress');
            const priceGap = 1;

            this.updatePrice(rangeInput);

            rangeInput.forEach((input) => {
              input.addEventListener('input', (event) => this.updatePrice(event));
            });

            priceInput.forEach((input) => {
              input.addEventListener('input', (e) => {
                let minVal = parseFloat(priceInput[0].value);
                let maxVal = parseFloat(priceInput[1].value);
                const min = parseFloat(input.min);
                const max = parseFloat(input.max);

                if (minVal < min) {
                  input.value = min;
                  minVal = min;
                }
                if (maxVal > max) {
                  input.value = max;
                  maxVal = max;
                }

                if (maxVal - minVal >= priceGap && maxVal <= 999999.99) {
                  if (e.target.className === 'input-min') {
                    rangeInput[0].value = minVal;
                    progress.style.left = (minVal / rangeInput[0].max) * 100 + '%';
                  } else {
                    rangeInput[1].value = maxVal;
                    progress.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + '%';
                  }
                }
              });
            });
          }

          updatePrice(e) {
            const rangeInput = this.querySelectorAll('.range-input input');
            const priceInput = this.querySelectorAll('.price-input input');
            const progress = this.querySelector('.slider .progress');
            const priceGap = 1;

            let minVal = parseInt(rangeInput[0].value);
            let maxVal = parseInt(rangeInput[1].value);

            if (maxVal - minVal < priceGap) {
              if (e.target.className === 'range-min') {
                rangeInput[0].value = maxVal - priceGap;
              } else {
                rangeInput[1].value = minVal + priceGap;
              }
            } else {
              priceInput[0].value = minVal;
              priceInput[1].value = maxVal;
              progress.style.left = (minVal / rangeInput[0].max) * 100 + '%';
              progress.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + '%';
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-blogs-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('starry-blogs-filter')) {
    customElements.define(
      'starry-blogs-filter',
      class StarryBlogsFilter extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.init();
        }
        init() {
          // 处理点击事件
          this.addEventListener('click', (e) => {
            this.compareCheckedTrigger(e);
          });
        }
        compareCheckedTrigger(e) {
          const tabOptions = document.querySelector('.ro-blog-tab__options');
          console.log(555);

          e.stopPropagation();
          // 找到被点击的元素
          let clickedElement = e.target.closest('a');
          if (!clickedElement) return;

          // 阻止默认行为（如果点击的是链接）
          if (e.target.closest('a')) {
            e.preventDefault();
          }

          // 获取所有a元素
          const allItems = tabOptions.querySelectorAll('a, li');

          // 更新所有项的data-selected属性
          allItems.forEach((item) => {
            item.setAttribute('data-selected', item === clickedElement ? 'true' : 'false');
          });

          // 如果是链接项，则手动导航（可选）
          const parentLink = clickedElement.closest('a');
          if (parentLink) {
            setTimeout(() => {
              window.location.href = parentLink.href;
            }, 100); // 添加轻微延迟让用户看到反馈
          }
        }
        compareDropdownTrigger() {
          event.stopPropagation();
          let selectDom = this.querySelector('.starry_blogs_select_main');
          let visibleValue = selectDom.getAttribute('data-visible');
          // 如果当前值是 'false'，则修改为 'true'，否则修改为 'false'
          let newVisibleValue = visibleValue === 'false' ? 'true' : 'false';
          selectDom.setAttribute('data-visible', newVisibleValue);
        }
        cleanAllDropdownSelect(e) {
          let className = e.target.className;
          console.log('className', className);
          if (className === 'starry_blogs_select_options') {
            return;
          }
          let selectDom = this.querySelector('.starry_blogs_select_main');
          if (selectDom.getAttribute('data-visible') === 'true') {
            selectDom.setAttribute('data-visible', 'false');
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-cart-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    // 获取添加到购物车按钮
    const addToCartButtons = document.querySelectorAll('.add-to-cart');

    addToCartButtons.forEach((button) => {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        // 获取变体ID
        const variantId = this.parentElement.querySelector('input[name="id"]').value;

        // Shopify 添加到购物车请求
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            // 添加到购物车成功后，调用 /cart.js 接口获取购物车内容
            window.location.href = '/checkout';
          })
          .catch((error) => {
            console.error('Error adding product to cart:', error);
            // 在此处处理错误，例如显示错误消息
          });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-cart-icon-bubble"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-cart-icon-bubble')) {
      customElements.define(
        'ro-cart-icon-bubble',
        class RoCartIconBubble extends HTMLElement {
          constructor() {
            super();
            this.cartTrigger = this.querySelector('.ro-header__cart_trigger');
          }

          connectedCallback() {
            // 新版mini-cart开关
            // this.init();
          }

          init() {
            this.cartTrigger.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              const entries = performance.getEntriesByType('resource');
              // 获取有多少个add.js请求
              const addJsCount = entries.filter((entry) => entry.name.includes('add.js')).length;
              if (addJsCount > window.redodo.addCartCount) {
                window.redodo.refreshCart(addJsCount);
              } else {
                if (window.location.pathname === '/cart') {
                  window.location.href = '/cart';
                } else {
                  document.querySelector('ro-cart-drawer').open();
                }
              }
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-cart-note"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-cart-note')) {
      customElements.define(
        'ro-cart-note',
        class RoCartNote extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            // 给textarea添加事件监听，增加防抖处理
            this.debounceTimer = null;
            this.querySelector('.ro-cart-note-input').addEventListener('input', () => {
              this.debouncedUpdateNote();
            });
          }
          debouncedUpdateNote() {
            // 清除之前的定时器
            if (this.debounceTimer) {
              clearTimeout(this.debounceTimer);
            }
            // 设置新的定时器，500ms后执行更新
            this.debounceTimer = setTimeout(() => {
              this.updateNote();
            }, 500);
          }
          updateNote() {
            const formData = {
              note: this.querySelector('.ro-cart-note-input').value,
            };
            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
            })
              .then((response) => response.json())
              .then((response) => {
                if (response.status && response.status !== 200) {
                  window.redodo.showToast('error', response.message);
                  return;
                }
              })
              .catch((error) => {
                console.error('Error:', error);
              });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-cart-order-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('ro-cart-order-details')) {
      customElements.define(
        'ro-cart-order-details',
        class RoCartOrderDetails extends HTMLElement {
          constructor() {
            super();
            this.countdownInterval = null;
            this.timeRemaining = 0;
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.discountInit();
            this.initCountdown();
            this.initCheckout();
            this.initTooltip();
          }
          discountInit() {
            this.querySelector('.ro-cart-order-details-main-discount-content-input').value =
              this.getKey('ro-cart-discount-code');
            const button = this.querySelector('.ro-cart-order-details-main-discount-content-input-box-btn');
            button.addEventListener('click', () => {
              button.dataset.loading = 'true';
              button.dataset.success = 'false';
              setTimeout(() => {
                button.dataset.loading = 'false';
                button.dataset.success = 'true';
                this.setKey(
                  'ro-cart-discount-code',
                  this.querySelector('.ro-cart-order-details-main-discount-content-input').value
                );
                setTimeout(() => {
                  button.dataset.loading = 'false';
                  button.dataset.success = 'false';
                }, 1000);
              }, 1000);
            });
          }
          getKey(key) {
            return localStorage.getItem(key);
          }
          setKey(key, value) {
            localStorage.setItem(key, value);
          }
          initCountdown() {
            this.countdownElement = this.querySelector('.ro-cart-order-details-main-total-info-countdown');
            if (!this.countdownElement) return;

            const startTsStr = this.countdownElement.getAttribute('data-start');
            const endTsStr = this.countdownElement.getAttribute('data-end');

            if (!endTsStr || endTsStr === '') return;

            const startTime = startTsStr !== '' ? parseInt(startTsStr, 10) * 1000 : null;
            const endTime = parseInt(endTsStr, 10) * 1000;
            if (Number.isNaN(endTime)) return;

            const now = Date.now();

            if (now > endTime) {
              this.countdownElement.style.display = 'none';
              return;
            }

            const hasStart = startTime !== null && !Number.isNaN(startTime);

            if (hasStart && now < startTime) {
              this.countdownElement.style.display = 'none';
            } else {
              this.timeRemaining = endTime - now;
              this.countdownElement.style.display = 'flex';
              this.renderCartCountdown(this.timeRemaining);
            }

            this.countdownInterval = setInterval(() => this.tickCartCountdown(), 1000);
          }
          disconnectedCallback() {
            if (this.countdownInterval) {
              clearInterval(this.countdownInterval);
            }
          }
          tickCartCountdown() {
            if (!this.countdownElement) return;

            const endTsStr = this.countdownElement.getAttribute('data-end');
            const startTsStr = this.countdownElement.getAttribute('data-start');

            const now = Date.now();
            const startTime = startTsStr ? parseInt(startTsStr, 10) * 1000 : null;
            const endTime = parseInt(endTsStr, 10) * 1000;

            if (Number.isNaN(endTime)) {
              this.countdownElement.style.display = 'none';
              clearInterval(this.countdownInterval);
              return;
            }

            if (now > endTime) {
              this.timeRemaining = 0;
              this.renderCartCountdown(0);
              this.countdownElement.style.display = 'none';
              clearInterval(this.countdownInterval);
              return;
            }

            const hasStart = startTime !== null && !Number.isNaN(startTime);
            if (hasStart && now < startTime) {
              this.countdownElement.style.display = 'none';
              return;
            }

            this.timeRemaining = endTime - now;
            this.countdownElement.style.display = 'flex';
            this.renderCartCountdown(this.timeRemaining);
          }
          renderCartCountdown(diff) {
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            const daysElement = this.countdownElement.querySelector('.days');
            const hoursElement = this.countdownElement.querySelector('.hrs');
            const minutesElement = this.countdownElement.querySelector('.min');
            const secondsElement = this.countdownElement.querySelector('.sec');

            if (daysElement) daysElement.textContent = days.toString().padStart(2, '0');
            if (hoursElement) hoursElement.textContent = hours.toString().padStart(2, '0');
            if (minutesElement) minutesElement.textContent = minutes.toString().padStart(2, '0');
            if (secondsElement) secondsElement.textContent = seconds.toString().padStart(2, '0');
          }
          initCheckout() {
            this.querySelector('.ro-cart-order-details-main-total-handle-check-out').addEventListener('click', () => {
              const checkOutBtn = this.querySelector('.ro-cart-order-details-main-total-handle-check-out');
              const button = checkOutBtn.querySelector('.global-button__button');
              if (button.getAttribute('data-loading') === 'true') return;
              button.setAttribute('data-loading', 'true');
              const discountCode = window.localStorage.getItem('ro-cart-discount-code');
              requestAnimationFrame(() => {
                if (discountCode) {
                  window.location.href = `/checkout?discount=${encodeURIComponent(discountCode)}`;
                } else {
                  window.location.href = `/checkout`;
                }
                button.setAttribute('data-loading', 'false');
              });
            });
          }
          initTooltip() {
            const tooltip = this.querySelector('.ro-cart-order-details-main-subtotal-shipping-tooltip');
            const tooltipText = this.querySelector('.ro-cart-order-details-main-subtotal-shipping-tooltip-text');

            if (!tooltip || !tooltipText) return;

            // 在初始化时预计算位置
            this.preCalculateTooltipPosition(tooltip, tooltipText);

            // 添加鼠标悬停事件
            tooltip.addEventListener('mouseenter', () => {
              tooltipText.style.opacity = '1';
            });

            tooltip.addEventListener('mouseleave', () => {
              tooltipText.style.opacity = '0';
            });

            // 添加窗口大小改变事件（重新预计算）
            window.addEventListener('resize', () => {
              this.preCalculateTooltipPosition(tooltip, tooltipText);
            });
          }
          preCalculateTooltipPosition(tooltip, tooltipText) {
            // 临时显示tooltip以获取准确尺寸
            const originalOpacity = tooltipText.style.opacity;
            tooltipText.style.opacity = '0';
            tooltipText.style.visibility = 'hidden'; // 隐藏但保持尺寸

            // 等待DOM更新后计算
            setTimeout(() => {
              const tooltipRect = tooltip.getBoundingClientRect();
              const tooltipTextRect = tooltipText.getBoundingClientRect();
              const viewportWidth = window.innerWidth;

              // 检查右侧是否被遮挡
              const rightEdge = tooltipTextRect.right;
              const isOverflowing = rightEdge > viewportWidth - 24;

              if (isOverflowing) {
                // 计算需要向左移动的距离
                const overflow = rightEdge - (viewportWidth - 24);
                const currentLeft = parseInt(tooltipText.style.left) || -9;
                const newLeft = currentLeft - overflow;
                const finalLeft = Math.max(-200, newLeft);
                tooltipText.style.left = `${finalLeft}px`;
              }

              // 预计算三角符号位置
              this.preCalculateArrowPosition(tooltip, tooltipText);

              // 恢复原始状态
              tooltipText.style.opacity = originalOpacity;
              tooltipText.style.visibility = 'visible';

              console.log('Pre-calculated tooltip position:', {
                isOverflowing,
                finalLeft: tooltipText.style.left,
                arrowLeft: tooltipText.style.getPropertyValue('--arrow-left'),
              });
            }, 50);
          }

          preCalculateArrowPosition(tooltip, tooltipText) {
            const tooltipRect = tooltip.getBoundingClientRect();
            const tooltipTextRect = tooltipText.getBoundingClientRect();

            // 计算图标中心位置
            const iconCenterX = tooltipRect.left + tooltipRect.width / 2;

            // 计算图标中心相对于tooltip左边缘的位置
            const relativeIconCenterX = iconCenterX - tooltipTextRect.left;

            // 考虑三角符号本身的宽度，调整中心点
            const arrowCenterOffset = 10;
            const adjustedIconCenterX = relativeIconCenterX - arrowCenterOffset;

            // 确保三角符号在tooltip范围内
            const arrowLeft = Math.max(8, Math.min(tooltipTextRect.width - 18, adjustedIconCenterX));

            // 设置三角符号位置
            tooltipText.style.setProperty('--arrow-left', `${arrowLeft}px`);
          }

          adjustTooltipPosition(tooltip, tooltipText) {
            // 多次尝试调整位置，确保第一次就正确
            this.adjustPositionWithRetry(tooltip, tooltipText, 0);
          }

          adjustPositionWithRetry(tooltip, tooltipText, attempt) {
            const maxAttempts = 3;
            const delay = attempt * 20 + 10; // 10ms, 30ms, 50ms

            setTimeout(() => {
              const tooltipRect = tooltip.getBoundingClientRect();
              const tooltipTextRect = tooltipText.getBoundingClientRect();
              const viewportWidth = window.innerWidth;

              // 检查右侧是否被遮挡
              const rightEdge = tooltipTextRect.right;
              const isOverflowing = rightEdge > viewportWidth - 24; // 24px边距

              console.log(`Tooltip position check (attempt ${attempt + 1}):`, {
                rightEdge,
                viewportWidth,
                isOverflowing,
                currentLeft: tooltipText.style.left,
                tooltipTextWidth: tooltipTextRect.width,
              });

              if (isOverflowing) {
                // 计算需要向左移动的距离
                const overflow = rightEdge - (viewportWidth - 24);
                const currentLeft = parseInt(tooltipText.style.left) || -9; // 默认-9px
                const newLeft = currentLeft - overflow;

                // 允许向左移动更多，只要不超过合理的左边界
                const finalLeft = Math.max(-200, newLeft); // 允许向左移动最多200px
                tooltipText.style.left = `${finalLeft}px`;

                console.log('Adjusting tooltip position:', {
                  overflow,
                  currentLeft,
                  newLeft,
                  finalLeft,
                });
              }

              // 调整三角符号位置
              this.adjustArrowPosition(tooltip, tooltipText);

              // 如果还有重试次数且位置可能不准确，继续重试
              if (attempt < maxAttempts - 1) {
                this.adjustPositionWithRetry(tooltip, tooltipText, attempt + 1);
              }
            }, delay);
          }
          adjustArrowPosition(tooltip, tooltipText) {
            // 等待DOM更新
            setTimeout(() => {
              const tooltipRect = tooltip.getBoundingClientRect();
              const tooltipTextRect = tooltipText.getBoundingClientRect();

              // 计算图标中心位置
              const iconCenterX = tooltipRect.left + tooltipRect.width / 2;

              // 计算图标中心相对于tooltip左边缘的位置
              const relativeIconCenterX = iconCenterX - tooltipTextRect.left;

              // 考虑三角符号本身的宽度（约20px），调整中心点
              const arrowCenterOffset = 10; // 三角符号宽度的一半
              const adjustedIconCenterX = relativeIconCenterX - arrowCenterOffset;

              // 确保三角符号在tooltip范围内，并指向图标中心
              const arrowLeft = Math.max(8, Math.min(tooltipTextRect.width - 18, adjustedIconCenterX));

              // 设置三角符号位置
              tooltipText.style.setProperty('--arrow-left', `${arrowLeft}px`);

              console.log('Adjusting arrow position:', {
                iconCenterX,
                tooltipTextLeft: tooltipTextRect.left,
                tooltipTextWidth: tooltipTextRect.width,
                relativeIconCenterX,
                adjustedIconCenterX,
                arrowLeft,
                iconRect: {
                  left: tooltipRect.left,
                  width: tooltipRect.width,
                },
                calculation: {
                  iconCenter: iconCenterX,
                  tooltipLeft: tooltipTextRect.left,
                  difference: relativeIconCenterX,
                  adjustedCenter: adjustedIconCenterX,
                  finalArrow: arrowLeft,
                },
              });
            }, 20);
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-cart-product-list"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('ro-cart-product-list')) {
      customElements.define(
        'ro-cart-product-list',
        class RoCartProductList extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.deleteEvent();
          }
          deleteEvent() {
            const deleteBox = this.querySelectorAll('.ro-cart-product-item-handle-delete-box');
            deleteBox.forEach((item) => {
              item.addEventListener('click', () => {
                // 像父元素中找到ro-drawer-product-item
                const productItem = item.closest('.ro-cart-product-item');
                const key = productItem.dataset.key;
                productItem.dataset.loading = 'true';
                const sections = document.querySelector('ro-cart').getAttribute('data-cart-section-id');
                let formData = { id: key, quantity: 0, sections: sections };
                fetch(window.Shopify.routes.root + 'cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(formData),
                })
                  .then((response) => response.json())
                  .then((response) => {
                    if (response.status && response.status !== 200) {
                      window.redodo.showToast('error', response.message);
                      return;
                    }
                    window.redodo.initCartMain(response.sections?.[sections]);
                  })
                  .catch((error) => {
                    console.error('Error:', error);
                  })
                  .finally(() => {
                    productItem.dataset.loading = 'false';
                  });
              });
            });
          }
        }
      );
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('ro-cart-product-item-handle-quantity-box')) {
      customElements.define(
        'ro-cart-product-item-handle-quantity-box',
        class RoCartProductItemHandleQuantityBox extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.quantityEvent();
          }
          quantityEvent() {
            this.min = 1;
            this.max = 999;
            this.currentValue = 1;
            this.input = this.querySelector('.ro-cart-product-item-handle-quantity-input');
            this.decreaseBtn = this.querySelector('.ro-cart-product-item-handle-quantity-btn_minus');
            this.increaseBtn = this.querySelector('.ro-cart-product-item-handle-quantity-btn_plus');

            // 设置初始值
            this.currentValue = parseInt(this.input.value) || 1;
            this.updateButtonStates();

            this.bindEvents();
          }
          bindEvents() {
            // 减号按钮事件
            this.decreaseBtn.addEventListener('click', () => {
              this.decreaseQuantity();
            });

            // 加号按钮事件
            this.increaseBtn.addEventListener('click', () => {
              this.increaseQuantity();
            });

            // 输入框事件
            this.input.addEventListener('change', (e) => {
              this.handleInputChange(e);
            });

            this.input.addEventListener('keydown', (e) => {
              if (e.key === 'Enter') {
                this.input.blur();
              }
            });
          }
          // 获取当前最大值
          getMaxQuantity() {
            const productItem = this.closest('.ro-cart-product-item');
            if (productItem) {
              const inventoryQuantity = Number(productItem.dataset.inventoryQuantity);
              const inventoryPolicy = productItem.dataset.inventoryPolicy;
              if (inventoryPolicy === 'continue') {
                return this.max;
              } else {
                return inventoryQuantity;
              }
            }
            return this.max;
          }

          decreaseQuantity() {
            if (this.decreaseBtn.getAttribute('data-disabled') === 'true') {
              return;
            }
            if (this.currentValue > this.min) {
              this.currentValue--;
              this.updateValue();
            }
          }

          increaseQuantity() {
            if (this.increaseBtn.getAttribute('data-disabled') === 'true') {
              window.redodo.showToast('error', this.dataset.maxTip);
              return;
            }
            if (this.currentValue < this.getMaxQuantity()) {
              this.currentValue++;
              this.updateValue();
            }
          }

          handleInputChange(e) {
            // 只允许输入数字
            let value = e.target.value.replace(/[^0-9]/g, '');

            // 如果为空，设置为最小值
            if (value === '') {
              value = this.min.toString();
            }

            // 转换为数字并限制范围
            let numValue = parseInt(value) || this.min;
            if (numValue < this.min) {
              numValue = this.min;
            } else if (numValue > this.getMaxQuantity()) {
              numValue = this.getMaxQuantity();
            }

            this.currentValue = numValue;

            this.updateValue();
          }

          updateValue() {
            const productItem = this.closest('.ro-cart-product-item');

            const key = productItem.dataset.key;
            productItem.dataset.loading = 'true';
            const sections = document.querySelector('ro-cart').getAttribute('data-cart-section-id');
            let formData = { id: key, quantity: this.currentValue, sections: sections };
            fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
            })
              .then((response) => response.json())
              .then((response) => {
                if (response.status && response.status !== 200) {
                  window.redodo.showToast('error', response.message);
                  return;
                }
                this.input.value = this.currentValue;
                this.updateButtonStates();
                const productItem = this.closest('.ro-cart-product-item');
                if (productItem) {
                  productItem.setAttribute('data-quantity', this.currentValue);
                }
                window.redodo.initCartMain(response.sections?.[sections]);
              })
              .catch((error) => {
                console.error('Error:', error);
              })
              .finally(() => {
                productItem.dataset.loading = 'false';
              });
          }

          updateButtonStates() {
            this.decreaseBtn.setAttribute('data-disabled', this.currentValue <= this.min);
            this.increaseBtn.setAttribute('data-disabled', this.currentValue >= this.getMaxQuantity());
          }
        }
      );
    }
  });
  document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-cart-product-item-info-detail-variant')) {
      customElements.define(
        'ro-cart-product-item-info-detail-variant',
        class extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.parentComponent = this.closest('.ro-cart-product-item'); // 父组件引用，用于访问其他选择器
            this.isOpen = false;
            this.selectedOption = null;

            this.init();
          }

          init() {
            this.selectButton = this.querySelector('.ro-cart-product-item-info-detail-variant-select-button');
            this.dropdown = this.querySelector('.ro-cart-product-item-info-detail-variant-dropdown');
            this.selectedText = this.querySelector('.ro-cart-product-item-info-detail-variant-select-button-text');
            this.chevron = this.querySelector('.chevron');
            this.options = this.querySelectorAll('.ro-cart-product-item-info-detail-variant-dropdown-option');

            this.bindEvents();
            this.setInitialSelection();
          }

          bindEvents() {
            // 点击选择按钮
            this.selectButton.addEventListener('click', (e) => {
              e.stopPropagation();
              this.toggleDropdown();
            });

            // 点击选项
            this.options.forEach((option) => {
              option.addEventListener('click', (e) => {
                e.stopPropagation();
                this.selectOption(option);
              });
            });

            // 点击外部关闭下拉框
            document.addEventListener('click', (e) => {
              if (!this.contains(e.target)) {
                this.closeDropdown();
              }
            });

            // ESC键关闭下拉框
            document.addEventListener('keydown', (e) => {
              if (e.key === 'Escape') {
                this.closeDropdown();
              }
            });
          }

          setInitialSelection() {
            const selectedOption = this.querySelector(
              '.ro-cart-product-item-info-detail-variant-dropdown-option.selected'
            );
            if (selectedOption) {
              this.selectedOption = selectedOption;
              this.selectedText.textContent = selectedOption.textContent.trim();
            }
          }

          toggleDropdown() {
            if (this.isOpen) {
              this.closeDropdown();
            } else {
              this.openDropdown();
            }
          }

          openDropdown() {
            this.isOpen = true;
            this.dropdown.classList.add('open');
            this.chevron.classList.add('open');
            this.selectButton.setAttribute('aria-expanded', 'true');
          }

          closeDropdown() {
            this.isOpen = false;
            this.dropdown.classList.remove('open');
            this.chevron.classList.remove('open');
            this.selectButton.setAttribute('aria-expanded', 'false');
          }

          selectOption(option) {
            // 移除之前的选中状态
            this.options.forEach((opt) => opt.classList.remove('selected'));

            // 设置新的选中状态
            option.classList.add('selected');
            this.selectedOption = option;
            // this.selectedText.textContent = option.textContent.trim();

            // TODO: 处理选择器变化逻辑
            // 1. 更新产品图片
            // 2. 更新产品价格
            // 3. 更新总价格
            // 4. 更新购物车数据
            this.handleOptionChange(option);

            this.closeDropdown();
          }

          // 处理选项变化
          handleOptionChange(option) {
            const variantId = option.dataset.variantId;
            const key = this.parentComponent.dataset.key;
            const quantity = Number(this.parentComponent.dataset.quantity);
            const inventoryPolicy = option.dataset.inventoryPolicy;
            const inventoryQuantity = Number(option.dataset.inventoryQuantity);
            const variantIds = this.parentComponent.closest('ro-cart').dataset.variantIds;
            const variantQuantities = this.parentComponent.closest('ro-cart').dataset.variantQuantities;
            const variantIdsList = variantIds.split(',');
            const variantQuantitiesList = variantQuantities.split(',');
            // 组合成对象
            const list = variantIdsList.map((item, index) => {
              return {
                variant_id: item,
                quantity: Number(variantQuantitiesList[index]),
              };
            });
            let num = quantity;
            let variant = list?.find((item) => item.variant_id === variantId);
            if (variant) {
              num = Number(variant.quantity) + quantity;
            }
            if (inventoryPolicy === 'deny') {
              num = Math.min(num, inventoryQuantity);
            }
            if (num > 999) {
              num = 999;
            }
            console.log(num);
            // TODO: 根据选择器索引更新对应的产品信息
            const sections = document.querySelector('ro-cart').getAttribute('data-cart-section-id');
            const formData = {
              updates: {
                [variantId]: num,
                [key]: 0,
              },
              sections: sections,
            };
            this.parentComponent.dataset.loading = 'true';
            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
            })
              .then((response) => response.json())
              .then((response) => {
                if (response.status && response.status !== 200) {
                  window.redodo.showToast('error', response.message);
                  return;
                }
                window.redodo.initCartMain(response.sections?.[sections]);
              })
              .catch((error) => {
                console.error('Error:', error);
              })
              .finally(() => {
                this.parentComponent.dataset.loading = 'false';
              });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-cart-recommend-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('ro-cart-recommend-product')) {
      customElements.define(
        'ro-cart-recommend-product',
        class RoCartRecommendProduct extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.addAddToCartEvent();
          }
          addAddToCartEvent() {
            this.querySelector('.ro-cart-recommend-product-add-to-cart-text').addEventListener('click', async () => {
              const addToCart = this.querySelector('.ro-cart-recommend-product-add-to-cart-text');
              const variantId = addToCart.dataset.variantId;
              const quantity = addToCart.dataset.quantity;
              const button = this.querySelector('.global-button__button');
              button.setAttribute('data-loading', 'true');
              try {
                const response = await window.redodo.addCart([{ id: variantId, quantity: quantity }]);
              } catch (error) {
                console.error('Error:', error);
              } finally {
                button.setAttribute('data-loading', 'false');
              }
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-drawer-discount-code"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-drawer-discount-code')) {
      customElements.define(
        'ro-drawer-discount-code',
        class RoDrawerNote extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.querySelector('.ro-drawer-discount-code-footer-cancel').addEventListener('click', () => {
              this.close();
            });
            this.querySelector('.ro-drawer-discount-code-footer-save').addEventListener('click', () => {
              this.setKey('ro-cart-discount-code', this.querySelector('.ro-drawer-discount-code-input').value);
              this.close();
            });
          }
          open() {
            this.setAttribute('data-open', 'true');
            this.querySelector('.ro-drawer-discount-code-input').value = this.getKey('ro-cart-discount-code');
          }
          //   感觉key值，拿到localStorge缓存数据
          getKey(key) {
            return localStorage.getItem(key);
          }
          setKey(key, value) {
            localStorage.setItem(key, value);
          }
          close() {
            this.setAttribute('data-open', 'false');
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-drawer-footer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-drawer-footer')) {
      customElements.define(
        'ro-drawer-footer',
        class RoDrawerFooter extends HTMLElement {
          constructor() {
            super();
            this.countdownInterval = null;
            this.timeRemaining = 0;
          }
          connectedCallback() {
            this.initCountdown();
            this.eventListener();
          }
          eventListener() {
            this.querySelector('.ro-drawer-footer-note-item-order-note').addEventListener('click', () => {
              this.openDrawerNote();
            });
            this.querySelector('.ro-drawer-footer-note-item-have-a-coupon').addEventListener('click', () => {
              this.openDrawerDiscountCode();
            });
            this.querySelector('.ro-drawer-footer-handle-check-out').addEventListener('click', () => {
              this.openDrawerCheckOut();
            });
            this.querySelector('.ro-drawer-footer-handle-view-cart').addEventListener('click', () => {
              this.openDrawerViewCart();
            });
          }
          openDrawerCheckOut() {
            const checkOutBtn = this.querySelector('.ro-drawer-footer-handle-check-out');
            const button = checkOutBtn.querySelector('.global-button__button');
            if (button.getAttribute('data-loading') === 'true') return;
            button.setAttribute('data-loading', 'true');
            const discountCode = window.localStorage.getItem('ro-cart-discount-code');
            requestAnimationFrame(() => {
              if (discountCode) {
                window.location.href = `/checkout?discount=${encodeURIComponent(discountCode)}`;
              } else {
                window.location.href = `/checkout`;
              }
              button.setAttribute('data-loading', 'false');
            });
          }
          async openDrawerViewCart() {
            const viewCartBtn = this.querySelector('.ro-drawer-footer-handle-view-cart');
            const button = viewCartBtn.querySelector('.global-button__button');
            if (button.getAttribute('data-loading') === 'true') return;
            button.setAttribute('data-loading', 'true');
            const discountCode = window.localStorage.getItem('ro-cart-discount-code');
            try {
              // 如果有discount code，请求discount接口
              if (discountCode) {
                await this.applyDiscountCode(discountCode);
              }

              // 跳转到cart页面
              window.location.href = '/cart';
            } catch (error) {
              console.error('Error applying discount code:', error);
              // 即使出错也跳转到cart页面
              window.location.href = '/cart';
            } finally {
              button.setAttribute('data-loading', 'false');
            }
          }
          // 应用discount  code的方法
          async applyDiscountCode(discountCode) {
            try {
              const response = await fetch('/discount/' + encodeURIComponent(discountCode), {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                },
              });

              if (response.ok) {
              } else {
              }
            } catch (error) {
              throw error;
            }
          }
          openDrawerNote() {
            document.querySelector('ro-cart-drawer ro-drawer-note').open();
          }
          openDrawerDiscountCode() {
            document.querySelector('ro-cart-drawer ro-drawer-discount-code').open();
          }
          initCountdown() {
            this.countdownElement = this.querySelector('.ro-drawer-footer-info-countdown');
            if (!this.countdownElement) return;

            const startTsStr = this.countdownElement.getAttribute('data-start');
            const endTsStr = this.countdownElement.getAttribute('data-end');

            if (!endTsStr || endTsStr === '') return;

            const startTime = startTsStr !== '' ? parseInt(startTsStr, 10) * 1000 : null;
            const endTime = parseInt(endTsStr, 10) * 1000;
            if (Number.isNaN(endTime)) return;

            const now = Date.now();

            if (now > endTime) {
              this.countdownElement.style.display = 'none';
              return;
            }

            const hasStart = startTime !== null && !Number.isNaN(startTime);

            if (hasStart && now < startTime) {
              this.countdownElement.style.display = 'none';
            } else {
              this.timeRemaining = endTime - now;
              this.countdownElement.style.display = 'flex';
              this.renderDrawerCountdown(this.timeRemaining);
            }

            this.countdownInterval = setInterval(() => this.tickDrawerCountdown(), 1000);
          }
          disconnectedCallback() {
            if (this.countdownInterval) {
              clearInterval(this.countdownInterval);
            }
          }
          tickDrawerCountdown() {
            if (!this.countdownElement) return;

            const endTsStr = this.countdownElement.getAttribute('data-end');
            const startTsStr = this.countdownElement.getAttribute('data-start');

            const now = Date.now();
            const startTime = startTsStr ? parseInt(startTsStr, 10) * 1000 : null;
            const endTime = parseInt(endTsStr, 10) * 1000;

            if (Number.isNaN(endTime)) {
              this.countdownElement.style.display = 'none';
              clearInterval(this.countdownInterval);
              return;
            }

            if (now > endTime) {
              this.timeRemaining = 0;
              this.renderDrawerCountdown(0);
              this.countdownElement.style.display = 'none';
              clearInterval(this.countdownInterval);
              return;
            }

            const hasStart = startTime !== null && !Number.isNaN(startTime);
            if (hasStart && now < startTime) {
              this.countdownElement.style.display = 'none';
              return;
            }

            this.timeRemaining = endTime - now;
            this.countdownElement.style.display = 'flex';
            this.renderDrawerCountdown(this.timeRemaining);
          }
          renderDrawerCountdown(diff) {
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            const daysElement = this.countdownElement.querySelector('.days');
            const hoursElement = this.countdownElement.querySelector('.hrs');
            const minutesElement = this.countdownElement.querySelector('.min');
            const secondsElement = this.countdownElement.querySelector('.sec');

            if (daysElement) daysElement.textContent = days.toString().padStart(2, '0');
            if (hoursElement) hoursElement.textContent = hours.toString().padStart(2, '0');
            if (minutesElement) minutesElement.textContent = minutes.toString().padStart(2, '0');
            if (secondsElement) secondsElement.textContent = seconds.toString().padStart(2, '0');
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-drawer-note"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-drawer-note')) {
      customElements.define(
        'ro-drawer-note',
        class RoDrawerNote extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.querySelector('.ro-drawer-note-footer-cancel').addEventListener('click', () => {
              this.close();
            });
            this.querySelector('.ro-drawer-note-footer-save').addEventListener('click', () => {
              this.save();
            });
          }
          save() {
            const saveButton = this.querySelector('.ro-drawer-note-footer-save');
            const button = saveButton.querySelector('.global-button__button');
            if (button.dataset.loading === 'true') {
              return;
            }
            const formData = {
              note: this.querySelector('.ro-drawer-note-input').value,
            };
            button.dataset.loading = 'true';
            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
            })
              .then((response) => response.json())
              .then((response) => {
                if (response.status && response.status !== 200) {
                  window.redodo.showToast('error', response.message);
                  return;
                }
                this.close();
              })
              .catch((error) => {
                console.error('Error:', error);
              })
              .finally(() => {
                button.dataset.loading = 'false';
              });
          }
          open() {
            this.setAttribute('data-open', 'true');
          }
          close() {
            this.setAttribute('data-open', 'false');
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-drawer-product-list"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('ro-drawer-product-list')) {
      customElements.define(
        'ro-drawer-product-list',
        class RoDrawerProductList extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.deleteEvent();
          }
          deleteEvent() {
            const deleteBox = this.querySelectorAll('.ro-drawer-product-item-info-bottom-delete-box');
            deleteBox.forEach((item) => {
              item.addEventListener('click', () => {
                // 像父元素中找到ro-drawer-product-item
                const productItem = item.closest('.ro-drawer-product-item');
                const key = productItem.dataset.key;
                productItem.dataset.loading = 'true';
                const sections = 'ro-cart-drawer';
                let formData = { id: key, quantity: 0, sections: sections };
                fetch(window.Shopify.routes.root + 'cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(formData),
                })
                  .then((response) => response.json())
                  .then((response) => {
                    if (response.status && response.status !== 200) {
                      window.redodo.showToast('error', response.message);
                      return;
                    }
                    window.redodo.initCart(response.sections?.[sections]);
                  })
                  .catch((error) => {
                    console.error('Error:', error);
                  })
                  .finally(() => {
                    productItem.dataset.loading = 'false';
                  });
              });
            });
          }
        }
      );
    }
  });
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('ro-drawer-product-item-info-bottom-quantity-box')) {
      customElements.define(
        'ro-drawer-product-item-info-bottom-quantity-box',
        class RoDrawerProductItemInfoBottomQuantityBox extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.quantityEvent();
          }
          quantityEvent() {
            this.min = 1;
            this.max = 999;
            this.currentValue = 1;
            this.input = this.querySelector('.ro-drawer-product-item-info-bottom-quantity-input');
            this.decreaseBtn = this.querySelector('.ro-drawer-product-item-info-bottom-quantity-btn_minus');
            this.increaseBtn = this.querySelector('.ro-drawer-product-item-info-bottom-quantity-btn_plus');

            // 设置初始值
            this.currentValue = parseInt(this.input.value) || 1;
            this.updateButtonStates();

            this.bindEvents();
          }
          bindEvents() {
            // 减号按钮事件
            this.decreaseBtn.addEventListener('click', () => {
              this.decreaseQuantity();
            });

            // 加号按钮事件
            this.increaseBtn.addEventListener('click', () => {
              this.increaseQuantity();
            });

            // 输入框事件
            this.input.addEventListener('change', (e) => {
              this.handleInputChange(e);
            });

            this.input.addEventListener('keydown', (e) => {
              if (e.key === 'Enter') {
                this.input.blur();
              }
            });
          }
          // 获取当前最大值
          getMaxQuantity() {
            const productItem = this.closest('.ro-drawer-product-item');
            if (productItem) {
              const inventoryQuantity = Number(productItem.dataset.inventoryQuantity);
              const inventoryPolicy = productItem.dataset.inventoryPolicy;
              if (inventoryPolicy === 'continue') {
                return this.max;
              } else {
                return inventoryQuantity;
              }
            }
            return this.max;
          }

          decreaseQuantity() {
            if (this.decreaseBtn.getAttribute('data-disabled') === 'true') {
              return;
            }
            if (this.currentValue > this.min) {
              this.currentValue--;
              this.updateValue();
            }
          }

          increaseQuantity() {
            if (this.increaseBtn.getAttribute('data-disabled') === 'true') {
              window.redodo.showToast('error', this.dataset.maxTip);
              return;
            }
            if (this.currentValue < this.getMaxQuantity()) {
              this.currentValue++;
              this.updateValue();
            }
          }

          handleInputChange(e) {
            // 只允许输入数字
            let value = e.target.value.replace(/[^0-9]/g, '');

            // 如果为空，设置为最小值
            if (value === '') {
              value = this.min.toString();
            }

            // 转换为数字并限制范围
            let numValue = parseInt(value) || this.min;
            if (numValue < this.min) {
              numValue = this.min;
            } else if (numValue > this.getMaxQuantity()) {
              numValue = this.getMaxQuantity();
            }

            this.currentValue = numValue;

            this.updateValue();
          }

          updateValue() {
            const productItem = this.closest('.ro-drawer-product-item');
            const key = productItem.dataset.key;
            productItem.dataset.loading = 'true';
            const sections = 'ro-cart-drawer';
            let formData = { id: key, quantity: this.currentValue, sections: sections };
            fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
            })
              .then((response) => response.json())
              .then((response) => {
                if (response.status && response.status !== 200) {
                  window.redodo.showToast('error', response.message);
                  return;
                }
                this.input.value = this.currentValue;
                this.updateButtonStates();
                const productItem = this.closest('.ro-drawer-product-item');
                if (productItem) {
                  productItem.setAttribute('data-quantity', this.currentValue);
                }
                window.redodo.initCart(response.sections?.[sections]);
              })
              .catch((error) => {
                console.error('Error:', error);
              })
              .finally(() => {
                productItem.dataset.loading = 'false';
              });
          }

          updateButtonStates() {
            this.decreaseBtn.setAttribute('data-disabled', this.currentValue <= this.min);
            this.increaseBtn.setAttribute('data-disabled', this.currentValue >= this.getMaxQuantity());
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-drawer-recommend-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-drawer-recommend-product')) {
      customElements.define(
        'ro-drawer-recommend-product',
        class extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            const url = this.getAttribute('data-url');
            fetch(url)
              .then((res) => res.text())
              .then((data) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, 'text/html');
                const recommendContainer = doc.querySelector('.ro-drawer-recommend-product');
                if (recommendContainer?.innerHTML.trim()) {
                  this.querySelector('.ro-drawer-recommend-product').innerHTML = recommendContainer.innerHTML;
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        }
      );
    }
  });
  document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-drawer-recommend-product-body')) {
      customElements.define(
        'ro-drawer-recommend-product-body',
        class extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            console.log('ro-drawer-recommend-product-body connected');
            window.starryEventBus.on('roInitStarrySwiper', () => {
              this.init();
            });
            // 轮询判断this.swiper是否初始化,同时判断Swiper是否存在,如果没有的话重新初始化,初始化后停止轮询
            this.interval = setInterval(() => {
              if (!this.swiper && window.Swiper) {
                this.init();
                clearInterval(this.interval);
              }
            }, 1000);
            this.addAddToCartEvent();
          }
          init() {
            const swiperDom = this.querySelector('.swiper');
            const swiperButtonPrev = document.querySelector(
              'ro-drawer-recommend-product .ro-drawer-recommend-product-header-handle-prev'
            );
            const swiperButtonNext = document.querySelector(
              'ro-drawer-recommend-product .ro-drawer-recommend-product-header-handle-next'
            );
            this.swiper = new Swiper(swiperDom, {
              slidesPerView: 'auto',
              spaceBetween: 16,
              navigation: {
                nextEl: swiperButtonNext,
                prevEl: swiperButtonPrev,
              },
              breakpoints: {
                577: {
                  spaceBetween: 24,
                },
              },
            });
          }
          addAddToCartEvent() {
            const addToCart = this.querySelectorAll('.ro-drawer-recommend-product-body-item-add-to-cart');
            addToCart.forEach((item) => {
              item.addEventListener('click', async () => {
                const variantId = item.dataset.variantId;
                const currentNum = 1;
                const button = item.querySelector('.global-button__button ');
                button.setAttribute('data-loading', 'true');

                try {
                  const response = await window.redodo.addCart([{ id: variantId, quantity: currentNum }]);
                } catch (error) {
                  console.error('Error:', error);
                } finally {
                  button.setAttribute('data-loading', 'false');
                }
              });
            });
          }
        }
      );
    }
  });
  document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-drawer-recommend-product-body-item-info-content-variant')) {
      customElements.define(
        'ro-drawer-recommend-product-body-item-info-content-variant',
        class extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.parentComponent = this.closest('.ro-drawer-recommend-product'); // 父组件引用，用于访问其他选择器
            this.isOpen = false;
            this.selectedOption = null;

            this.init();
          }

          init() {
            this.selectButton = this.querySelector(
              '.ro-drawer-recommend-product-body-item-info-content-variant-select-button'
            );
            this.dropdown = this.querySelector('.ro-drawer-recommend-product-body-item-info-content-variant-dropdown');
            this.selectedText = this.querySelector(
              '.ro-drawer-recommend-product-body-item-info-content-variant-select-button-text'
            );
            this.chevron = this.querySelector('.chevron');
            this.options = this.querySelectorAll(
              '.ro-drawer-recommend-product-body-item-info-content-variant-dropdown-option'
            );

            this.bindEvents();
            this.setInitialSelection();
          }

          bindEvents() {
            // 点击选择按钮
            this.selectButton.addEventListener('click', (e) => {
              e.stopPropagation();
              this.toggleDropdown();
            });

            // 点击选项
            this.options.forEach((option) => {
              option.addEventListener('click', (e) => {
                e.stopPropagation();
                this.selectOption(option);
              });
            });

            // 点击外部关闭下拉框
            document.addEventListener('click', (e) => {
              if (!this.contains(e.target)) {
                this.closeDropdown();
              }
            });

            // ESC键关闭下拉框
            document.addEventListener('keydown', (e) => {
              if (e.key === 'Escape') {
                this.closeDropdown();
              }
            });
          }

          setInitialSelection() {
            const selectedOption = this.querySelector(
              '.ro-drawer-recommend-product-body-item-info-content-variant-dropdown-option.selected'
            );
            if (selectedOption) {
              this.selectedOption = selectedOption;
              this.selectedText.textContent = selectedOption.textContent.trim();
            }
          }

          toggleDropdown() {
            if (this.isOpen) {
              this.closeDropdown();
            } else {
              this.openDropdown();
            }
          }

          openDropdown() {
            this.isOpen = true;
            this.dropdown.classList.add('open');
            this.chevron.classList.add('open');
            this.selectButton.setAttribute('aria-expanded', 'true');
          }

          closeDropdown() {
            this.isOpen = false;
            this.dropdown.classList.remove('open');
            this.chevron.classList.remove('open');
            this.selectButton.setAttribute('aria-expanded', 'false');
          }

          selectOption(option) {
            // 移除之前的选中状态
            this.options.forEach((opt) => opt.classList.remove('selected'));

            // 设置新的选中状态
            option.classList.add('selected');
            this.selectedOption = option;
            this.selectedText.textContent = option.textContent.trim();

            // TODO: 处理选择器变化逻辑
            // 1. 更新产品图片
            // 2. 更新产品价格
            // 3. 更新总价格
            // 4. 更新购物车数据
            this.handleOptionChange(option);

            this.closeDropdown();
          }

          // 处理选项变化
          handleOptionChange(option) {
            const productId = option.dataset.productId;
            const variantId = option.dataset.variantId;
            const price = option.dataset.price;
            const compareAtPrice = option.dataset.compareAtPrice;
            const image = option.dataset.image;

            // TODO: 根据选择器索引更新对应的产品信息
            this.updateRecommendProduct(productId, variantId, price, compareAtPrice, image);
          }

          // 更新推荐产品信息
          updateRecommendProduct(productId, variantId, price, compareAtPrice, image) {
            // TODO: 实现推荐产品信息更新逻辑
            const formatMoney = document.querySelector('ro-drawer-recommend-product').dataset.formatMoney;
            const recommendProduct = this.parentComponent.querySelector(
              `.ro-drawer-recommend-product-body-item[data-product-id="${productId}"]`
            );
            console.log(recommendProduct);
            // 更新数据
            if (recommendProduct) {
              recommendProduct.querySelector('.ro-drawer-recommend-product-body-item-info-image').src = image;
              recommendProduct.querySelector('.ro-drawer-recommend-product-body-item-info-price-new').innerHTML =
                Shopify.formatMoney(price, formatMoney);
              recommendProduct.querySelector('.ro-drawer-recommend-product-body-item-info-price-old').innerHTML =
                Shopify.formatMoney(compareAtPrice, formatMoney);
              if (compareAtPrice > price) {
                recommendProduct
                  .querySelector('.ro-drawer-recommend-product-body-item-info-price-old')
                  .classList.remove('hidden');
              } else {
                recommendProduct
                  .querySelector('.ro-drawer-recommend-product-body-item-info-price-old')
                  .classList.add('hidden');
              }
              const addToCart = recommendProduct.querySelector('.ro-drawer-recommend-product-body-item-add-to-cart');
              if (addToCart) {
                addToCart.setAttribute('data-variant-id', variantId);
              }
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-product-content-countdown"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-product-content-countdown')) {
      customElements.define(
        'ro-product-content-countdown',
        class RoProductContentCountdown extends HTMLElement {
          constructor() {
            super();
            this.countdownInterval = null;
            this.timeRemaining = 0;
          }

          connectedCallback() {
            this.initCountdown();
          }

          disconnectedCallback() {
            if (this.countdownInterval) {
              clearInterval(this.countdownInterval);
            }
          }

          initCountdown() {
            const startTsStr = this.getAttribute('data-start');
            const endTsStr = this.getAttribute('data-end');

            if (!endTsStr || endTsStr === '') return;

            const startTime = startTsStr !== '' ? parseInt(startTsStr, 10) * 1000 : null;
            const endTime = parseInt(endTsStr, 10) * 1000;
            if (Number.isNaN(endTime)) return;

            const now = Date.now();

            if (now > endTime) {
              this.style.display = 'none';
              return;
            }

            const hasStart = startTime !== null && !Number.isNaN(startTime);

            if (hasStart && now < startTime) {
              this.style.display = 'none';
            } else {
              this.timeRemaining = endTime - now;
              this.style.display = 'block';
              this.renderTime(this.timeRemaining);
            }

            this.startTimer();
          }

          startTimer() {
            this.countdownInterval = setInterval(() => {
              const endTsStr = this.getAttribute('data-end');
              const startTsStr = this.getAttribute('data-start');

              const now = Date.now();
              const startTime = startTsStr ? parseInt(startTsStr, 10) * 1000 : null;
              const endTime = parseInt(endTsStr, 10) * 1000;

              if (Number.isNaN(endTime)) {
                this.style.display = 'none';
                clearInterval(this.countdownInterval);
                return;
              }

              if (now > endTime) {
                this.timeRemaining = 0;
                this.renderTime(0);
                this.style.display = 'none';
                clearInterval(this.countdownInterval);
                return;
              }

              const hasStart = startTime !== null && !Number.isNaN(startTime);
              if (hasStart && now < startTime) {
                this.style.display = 'none';
                return;
              }

              this.timeRemaining = endTime - now;
              this.style.display = 'block';
              this.renderTime(this.timeRemaining);
            }, 1000);
          }

          renderTime(diff) {
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            const daysElement = this.querySelector('.days');
            const hoursElement = this.querySelector('.hrs');
            const minutesElement = this.querySelector('.min');
            const secondsElement = this.querySelector('.sec');

            if (daysElement) daysElement.textContent = days.toString().padStart(2, '0');
            if (hoursElement) hoursElement.textContent = hours.toString().padStart(2, '0');
            if (minutesElement) minutesElement.textContent = minutes.toString().padStart(2, '0');
            if (secondsElement) secondsElement.textContent = seconds.toString().padStart(2, '0');
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-product-content-description"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-product-content-description')) {
      customElements.define(
        'ro-product-content-description',
        class RoProductContentDescription extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.content = this.querySelector('.ro-product-content-description__content');

            this.viewMore = this.querySelector('.ro-product-content-description__view_more');
            this.viewMoreContent = this.querySelector('.ro-product-content-description__view_more_content');
            this.viewLessContent = this.querySelector('.ro-product-content-description__view_less_content');

            // 检查是否需要显示展开/收起功能
            this.checkContentHeight();

            this.viewMoreContent.addEventListener('click', () => {
              this.viewMoreContentFn();
            });
            this.viewLessContent.addEventListener('click', () => {
              this.viewLessContentFn();
            });

            // 监听窗口大小变化
            window.addEventListener('resize', () => {
              this.checkContentHeight();
            });
          }

          checkContentHeight() {
            // 临时移除高度限制来获取实际内容高度
            const originalMaxHeight = this.content.style.maxHeight;
            this.content.style.maxHeight = 'none';
            const actualHeight = this.content.scrollHeight;
            this.content.style.maxHeight = originalMaxHeight;

            // 获取当前屏幕宽度
            const screenWidth = window.innerWidth;

            // 根据屏幕尺寸判断是否需要显示展开/收起功能
            let shouldShowToggle = true;

            if (screenWidth > 1200) {
              // PC端：大于1200px，高度不超过270px时隐藏
              shouldShowToggle = actualHeight > 270;
            } else {
              // 移动端：小于等于1200px，高度不超过300px时隐藏
              shouldShowToggle = actualHeight > 300;
            }

            // 根据判断结果显示或隐藏展开/收起按钮
            if (!shouldShowToggle) {
              this.viewMore.style.display = 'none';
              this.viewLessContent.style.display = 'none';
              this.content.style.maxHeight = 'none';
            } else {
              this.viewMore.style.display = 'flex';
              this.viewLessContent.style.display = 'flex';
            }
          }
          viewMoreContentFn() {
            this.defaultMaxHeight = this.content.style.maxHeight;
            // 获取内容的实际高度
            const scrollHeight = this.content.scrollHeight;
            // 设置平滑的高度过渡
            this.content.style.maxHeight = scrollHeight + 'px';
            this.viewMore.style.display = 'none';
            this.viewLessContent.style.opacity = 1;
          }
          viewLessContentFn() {
            this.content.style.maxHeight = this.defaultMaxHeight;
            this.viewMore.style.display = 'flex';
            this.viewLessContent.style.opacity = 0;
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-product-content-discount-code"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('ro-product-content-discount-code')) {
      customElements.define(
        'ro-product-content-discount-code',
        class RoProductContentDiscountCode extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            const btn = this.querySelector('.ro-product-content-discount-code__content_btn');
            btn.addEventListener('click', (e) => {
              const code = e.target.getAttribute('data-code').trim();
              // 兼容safri浏览器 谷歌浏览器
              if (navigator.clipboard) {
                navigator.clipboard.writeText(code);
              } else {
                const textarea = document.createElement('textarea');
                textarea.value = code;
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
              }
              const copyText = this.getAttribute('data-copy-text');
              const copiedText = this.getAttribute('data-copied-text');
              btn.textContent = copiedText;
              setTimeout(() => {
                btn.textContent = copyText;
              }, 1000);
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-product-content-product-info"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('ro-product-content-product-info')) {
      customElements.define(
        'ro-product-content-product-info',
        class RoProductContentProductInfo extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            console.log('ro-product-content-product-info init');
            this.addAddToCartEvent();
            this.addBuyItNowEvent();
            this.addNotifyMeEvent();
          }
          addNotifyMeEvent() {
            const notifyMe = this.querySelector('.ro-product-content-product-info__panel_btns_notify_me');
            notifyMe.addEventListener('click', () => {
              const notifyModal = document.querySelector('global-stock-notify-modal');
              const stickyForm = document.querySelector('ro-product-sticky-form');
              const variantId = stickyForm.dataset.currentVariantId;
              if (variantId && notifyModal) {
                notifyModal.open(variantId);
              }
            });
          }
          addAddToCartEvent() {
            const addToCart = this.querySelector('.ro-product-content-product-info__panel_btns_add_to_cart');
            addToCart.addEventListener('click', async () => {
              const button = addToCart.querySelector('.global-button__button');
              const stickyForm = document.querySelector('ro-product-sticky-form');
              const currentNum = stickyForm.dataset.quantity;
              const variantId = stickyForm.dataset.currentVariantId;
              button.setAttribute('data-loading', 'true');
              try {
                const response = await window.redodo.addCart([{ id: variantId, quantity: currentNum }]);
              } catch (error) {
                console.error('Error:', error);
              } finally {
                button.setAttribute('data-loading', 'false');
              }
            });
          }
          addBuyItNowEvent() {
            const buyItNow = this.querySelector('.ro-product-content-product-info__panel_btns_buy_it_now');
            if (buyItNow) {
              buyItNow.addEventListener('click', () => {
                console.log('buyItNow');
                const button = buyItNow.querySelector('.global-button__button');
                const stickyForm = document.querySelector('ro-product-sticky-form');
                const variantId = stickyForm.dataset.currentVariantId;
                const quantity = stickyForm.dataset.quantity;
                const items = [`${parseInt(variantId)}:${parseInt(quantity)}`];
                let cartUrl = `/cart/${items.join(',')}`;
                requestAnimationFrame(() => {
                  window.location.href = cartUrl;
                });
              });
            }
          }

          // 提供给外部调用，更新价格和折扣信息
          updatePriceInfo(priceInfo, quantity) {
            const currentPrice = Number(priceInfo.price);
            const currentCompareAtPrice = Number(priceInfo.compareAtPrice);
            // 更新价格
            this.querySelector('.ro-product-content-product-info__panel_info_price_new').innerHTML =
              Shopify.formatMoney(currentPrice * quantity, this.dataset.formatMoney);
            // this.querySelector('.ro-product-content-product-info__panel_info_price_old').innerHTML =
            //   Shopify.formatMoney(currentCompareAtPrice * quantity, this.dataset.formatMoney);
            // if (currentCompareAtPrice && currentCompareAtPrice > currentPrice) {
            //   this.querySelector('.ro-product-content-product-info__panel_info_price_old').classList.remove('hidden');
            // } else {
            //   this.querySelector('.ro-product-content-product-info__panel_info_price_old').classList.add('hidden');
            // }

            // 更新折扣信息
            if (this.dataset.showProductInfoDiscount == 'true') {
              let shouldShowDiscount = currentCompareAtPrice && currentCompareAtPrice > currentPrice;
              switch (this.dataset.globalProductDiscountType) {
                case 'percentage':
                  // 计算折扣百分比,向下取整
                  const discountPercentage = ((currentCompareAtPrice - currentPrice) / currentCompareAtPrice) * 100;
                  const floorDiscountPercentage = Math.floor(discountPercentage);
                  this.querySelector('.ro-product-content-product-info__panel_info_price_discount_num').textContent =
                    floorDiscountPercentage;
                  // 如果百分比为0，则不显示折扣
                  if (floorDiscountPercentage === 0) {
                    shouldShowDiscount = false;
                  }
                  break;
                case 'quota':
                  // 计算折扣额度
                  const discountQuota = currentCompareAtPrice - currentPrice;
                  this.querySelector('.ro-product-content-product-info__panel_info_price_discount_num').innerHTML =
                    Shopify.formatMoney(discountQuota * quantity, this.dataset.formatMoney);
                  break;
              }

              // 更新折扣信息显示
              if (shouldShowDiscount) {
                this.querySelector('.ro-product-content-product-info__panel_info_price_discount').classList.remove(
                  'hidden'
                );
              } else {
                this.querySelector('.ro-product-content-product-info__panel_info_price_discount').classList.add(
                  'hidden'
                );
              }
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-product-content-product-set"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-product-content-product-set')) {
      customElements.define(
        'ro-product-content-product-set',
        class RoProductContentProductSet extends HTMLElement {
          constructor() {
            super();
            this.selectedOption = null;
          }

          connectedCallback() {
            this.init();
          }

          init() {
            this.options = this.querySelectorAll('.ro-product-content-product-set__option');
            this.bindEvents();
            this.setInitialSelection();
          }

          bindEvents() {
            // 点击选项
            this.options.forEach((option) => {
              option.addEventListener('click', (e) => {
                e.preventDefault();
                this.selectOption(option);
              });
            });
          }

          setInitialSelection() {
            // 通过当前页面 URL 匹配选项
            const currentPath = window.location.pathname;
            const currentOption = Array.from(this.options).find((opt) => {
              try {
                const optionUrl = new URL(opt.href, window.location.origin);
                return optionUrl.pathname === currentPath;
              } catch (e) {
                // 如果 href 是相对路径，直接比较
                return opt.getAttribute('href') === currentPath;
              }
            });

            if (currentOption) {
              this.selectOption(currentOption, false);
            } else {
              // 如果没有找到匹配的，保持第一个选中状态
              const selectedOption = this.querySelector('.ro-product-content-product-set__option.selected');
              if (selectedOption) {
                this.selectedOption = selectedOption;
              }
            }
          }

          selectOption(option, navigate = true) {
            // 移除之前的选中状态
            this.options.forEach((opt) => opt.classList.remove('selected'));

            // 设置新的选中状态
            option.classList.add('selected');
            this.selectedOption = option;

            // 如果需要导航，跳转到产品页面
            if (navigate && option.href) {
              window.location.href = option.href;
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-product-content-quantity"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-product-content-quantity')) {
      customElements.define(
        'ro-product-content-quantity',
        class RoProductContentQuantity extends HTMLElement {
          constructor() {
            super();
            this.min = 1;
            this.max = 999;
            this.currentValue = 1;
          }

          connectedCallback() {
            this.init();
          }

          init() {
            this.input = this.querySelector('input');
            this.decreaseBtn = this.querySelector('.ro-product-content-quantity__btn_minus');
            this.increaseBtn = this.querySelector('.ro-product-content-quantity__btn_plus');

            // 设置初始值
            this.currentValue = parseInt(this.input.value) || 1;
            this.updateButtonStates();

            this.bindEvents();
          }
          // 提供外部调用，数据更新
          updateQuantity(quantity) {
            this.currentValue = quantity;
            this.updateValue();
          }

          bindEvents() {
            // 减号按钮事件
            this.decreaseBtn.addEventListener('click', () => {
              this.decreaseQuantity();
            });

            // 加号按钮事件
            this.increaseBtn.addEventListener('click', () => {
              this.increaseQuantity();
            });

            // 输入框事件
            this.input.addEventListener('change', (e) => {
              this.handleInputChange(e);
            });

            this.input.addEventListener('keydown', (e) => {
              if (e.key === 'Enter') {
                this.input.blur();
              }
            });
          }
          // 获取当前最大值
          getMaxQuantity() {
            const stickyForm = document.querySelector('ro-product-sticky-form');
            if (stickyForm) {
              const inventoryQuantity = Number(stickyForm.dataset.inventoryQuantity);
              const inventoryPolicy = stickyForm.dataset.inventoryPolicy;
              if (inventoryPolicy === 'continue') {
                return this.max;
              } else {
                return inventoryQuantity;
              }
            }
            return this.max;
          }

          decreaseQuantity() {
            if (this.decreaseBtn.getAttribute('data-disabled') === 'true') {
              return;
            }
            if (this.currentValue > this.min) {
              this.currentValue--;
              this.updateValue();
            }
          }

          increaseQuantity() {
            if (this.increaseBtn.getAttribute('data-disabled') === 'true') {
              window.redodo.showToast('error', this.dataset.maxTip);
              return;
            }
            if (this.currentValue < this.getMaxQuantity()) {
              this.currentValue++;
              this.updateValue();
            }
          }

          handleInputChange(e) {
            // 只允许输入数字
            let value = e.target.value.replace(/[^0-9]/g, '');

            // 如果为空，设置为最小值
            if (value === '') {
              value = this.min.toString();
            }

            // 转换为数字并限制范围
            let numValue = parseInt(value) || this.min;
            if (numValue < this.min) {
              numValue = this.min;
            } else if (numValue > this.getMaxQuantity()) {
              numValue = this.getMaxQuantity();
            }

            this.currentValue = numValue;

            this.updateValue();
          }

          updateValue() {
            this.input.value = this.currentValue;
            this.updateButtonStates();
            const stickyForm = document.querySelector('ro-product-sticky-form');
            if (stickyForm) {
              stickyForm.setAttribute('data-quantity', this.currentValue);
            }
          }

          updateButtonStates() {
            this.decreaseBtn.setAttribute('data-disabled', this.currentValue <= this.min);
            this.increaseBtn.setAttribute('data-disabled', this.currentValue >= this.getMaxQuantity());
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-product-content-recommend-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('ro-product-content-recommend-product')) {
      customElements.define(
        'ro-product-content-recommend-product',
        class RoProductContentRecommendProduct extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            const url = this.getAttribute('data-url');
            if (!url) return;
            fetch(url)
              .then((res) => res.text())
              .then((data) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(data, 'text/html');
                const recommendContainer = doc.querySelector('.ro-product-content-recommend-product');
                if (recommendContainer && recommendContainer.innerHTML.trim()) {
                  this.querySelector('.ro-product-content-recommend-product').innerHTML = recommendContainer.innerHTML;
                  // 确保有数据时展示组件
                  this.style.display = '';
                } else {
                  // 没有推荐商品时隐藏整个组件
                  this.style.display = 'none';
                }
              })
              .catch((err) => {
                console.log(err);
                this.style.display = 'none';
              });
          }
          // 提供外部调用，更新当前产品选中变体
          updateSelectedVariant(variantId) {
            const currentProduct = this.querySelector(
              '.ro-product-content-recommend-product-list__content_current_product'
            );
            // 触发点击事件
            if (currentProduct) {
              const option = currentProduct.querySelector(
                `.ro-product-content-recommend-product-list__option[data-variant-id="${variantId}"]`
              );
              if (option) {
                option.click();
              }
            }
          }
        }
      );
    }
    if (!customElements.get('ro-product-content-recommend-product-list')) {
      customElements.define(
        'ro-product-content-recommend-product-list',
        class RoProductContentRecommendProductList extends HTMLElement {
          constructor() {
            super();
            this.selectors = []; // 存储所有选择器实例
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initSelectors();
            this.initCheckboxes();
            this.initAllAddToCart();
            this.initItemAddToCart();
            // 由于推荐商品无法获取到元字段中当前变体的选择，所以需要初始化一下获取ro-product-content-sticky-form中的当前变体
            const stickyForm = document.querySelector('ro-product-sticky-form');
            if (stickyForm) {
              // ro-product-content-recommend-product中的 updateSelectedVariant
              const currentVariantId = stickyForm.dataset.currentVariantId;
              const recommendProduct = document.querySelector('ro-product-content-recommend-product');
              if (recommendProduct) {
                recommendProduct.updateSelectedVariant(currentVariantId);
              }
            }
          }

          initItemAddToCart() {
            const addToCart = this.querySelectorAll(
              '.ro-product-content-recommend-product-list__content_item_add_to_cart'
            );
            addToCart.forEach((item) => {
              item.addEventListener('click', async (e) => {
                e.stopPropagation();
                const button = item.querySelector('.global-button__button');
                button.setAttribute('data-loading', 'true');
                const variantId = item.dataset.variantId;
                try {
                  const response = await window.redodo.addCart([{ id: variantId, quantity: 1 }]);
                } catch (error) {
                  console.error('Error:', error);
                } finally {
                  button.setAttribute('data-loading', 'false');
                }
              });
            });
          }
          initAllAddToCart() {
            const addToCart = this.querySelector('.ro-product-content-recommend-product-list__footer_btn');
            addToCart.addEventListener('click', async (e) => {
              e.stopPropagation();
              const button = addToCart.querySelector('.global-button__button');
              button.setAttribute('data-loading', 'true');
              const stickyForm = document.querySelector('ro-product-sticky-form');
              const currentNum = stickyForm.dataset.quantity;
              const otherVariants = JSON.parse(this.getAttribute('data-other-variants'));
              const currentVariant = this.getAttribute('data-current-variant');
              const currentPrice = this.getAttribute('data-current-price');
              const currentCompareAtPrice = this.getAttribute('data-current-compare-at-price');
              let formData = {
                items: [{ id: currentVariant, quantity: currentNum }],
              };
              otherVariants.forEach((item) => {
                formData.items.push({ id: item.variantId, quantity: 1 });
              });
              try {
                const response = await window.redodo.addCart(formData.items);
              } catch (error) {
                console.error('Error:', error);
              } finally {
                button.setAttribute('data-loading', 'false');
              }
            });
          }
          initCheckboxes() {
            const checkboxes = this.querySelectorAll(
              '.ro-product-content-recommend-product-list__content_item_checkbox'
            );
            checkboxes.forEach((checkbox) => {
              checkbox.addEventListener('click', (e) => {
                e.stopPropagation();
                checkbox.classList.toggle('checked');
                const productId = checkbox.dataset.productId;
                const variantId = checkbox.dataset.variantId;
                const price = checkbox.dataset.price;
                const compareAtPrice = checkbox.dataset.compareAtPrice;
                let obj = {
                  productId: productId,
                  variantId: variantId,
                  price: price,
                  compareAtPrice: compareAtPrice,
                };
                let otherVariants = JSON.parse(this.getAttribute('data-other-variants'));
                // 判断是否已经存在，不存在就添加，存在就删除
                const isExist = otherVariants.some((item) => item.productId === productId);
                if (isExist) {
                  otherVariants.splice(
                    otherVariants.findIndex((item) => item.productId === productId),
                    1
                  );
                } else {
                  otherVariants.push(obj);
                }
                this.setAttribute('data-other-variants', JSON.stringify(otherVariants));
                this.updateTotalPrice();
              });
            });
          }

          // 初始化所有选择器
          initSelectors() {
            // 查找所有选择器容器
            const selectorContainers = this.querySelectorAll('.ro-product-content-recommend-product-list__select');

            selectorContainers.forEach((container, index) => {
              const selector = new ProductSelector(container, index, this);
              this.selectors.push(selector);
            });
          }
          // 更新总价格
          updateTotalPrice() {
            const stickyForm = document.querySelector('ro-product-sticky-form');
            const formatMoney = document.querySelector('ro-product-content-recommend-product').dataset.formatMoney;
            const currentNum = stickyForm.dataset.quantity;
            const otherVariants = JSON.parse(this.getAttribute('data-other-variants'));
            const currentPrice = this.getAttribute('data-current-price');
            const totalPrice = otherVariants.reduce(
              (acc, item) => acc + Number(item.price),
              Number(currentPrice) * Number(currentNum)
            );
            this.querySelector('.ro-product-content-recommend-product-list__footer_price_new').innerHTML =
              Shopify.formatMoney(totalPrice, formatMoney);
            // 更新当前产品比较价格
            const currentCompareAtPrice = this.getAttribute('data-current-compare-at-price');
            const totalCompareAtPrice = otherVariants.reduce(
              (acc, item) => acc + Number(item.compareAtPrice),
              Number(currentCompareAtPrice) * Number(currentNum)
            );
            if (totalCompareAtPrice > totalPrice) {
              this.querySelector('.ro-product-content-recommend-product-list__footer_price_old').classList.remove(
                'hidden'
              );
              this.querySelector('.ro-product-content-recommend-product-list__footer_price_old').innerHTML =
                Shopify.formatMoney(totalCompareAtPrice, formatMoney);
            } else {
              this.querySelector('.ro-product-content-recommend-product-list__footer_price_old').classList.add(
                'hidden'
              );
              this.querySelector('.ro-product-content-recommend-product-list__footer_price_old').innerHTML =
                Shopify.formatMoney(totalCompareAtPrice, formatMoney);
            }
          }
        }
      );
    }

    // 产品选择器类
    class ProductSelector {
      constructor(container, index, parentComponent) {
        this.container = container;
        this.index = index;
        this.parentComponent = parentComponent; // 父组件引用，用于访问其他选择器
        this.isOpen = false;
        this.selectedOption = null;

        this.init();
      }

      init() {
        this.selectButton = this.container.querySelector('.ro-product-content-recommend-product-list__select-button');
        this.dropdown = this.container.querySelector('.ro-product-content-recommend-product-list__dropdown');
        this.selectedText = this.container.querySelector('.ro-product-content-recommend-product-list__selected-text');
        this.chevron = this.container.querySelector('.chevron');
        this.options = this.container.querySelectorAll('.ro-product-content-recommend-product-list__option');

        this.bindEvents();
        this.setInitialSelection();
      }

      bindEvents() {
        // 点击选择按钮
        this.selectButton.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleDropdown();
        });

        // 点击选项
        this.options.forEach((option) => {
          option.addEventListener('click', (e) => {
            e.stopPropagation();
            this.selectOption(option);
          });
        });

        // 点击外部关闭下拉框
        document.addEventListener('click', (e) => {
          if (!this.container.contains(e.target)) {
            this.closeDropdown();
          }
        });

        // ESC键关闭下拉框
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            this.closeDropdown();
          }
        });
      }

      setInitialSelection() {
        const selectedOption = this.container.querySelector(
          '.ro-product-content-recommend-product-list__option.selected'
        );
        if (selectedOption) {
          this.selectedOption = selectedOption;
          this.selectedText.textContent = selectedOption.textContent.trim();
        }
      }

      toggleDropdown() {
        if (this.isOpen) {
          this.closeDropdown();
        } else {
          this.openDropdown();
        }
      }

      openDropdown() {
        // 先关闭其他所有选择器
        this.closeOtherSelectors();

        this.isOpen = true;
        this.dropdown.classList.add('open');
        this.chevron.classList.add('open');
        this.selectButton.setAttribute('aria-expanded', 'true');

        // 修复滚动逻辑：等待下拉框完全展开后计算滚动位置
        setTimeout(() => {
          this.scrollToShowDropdown();
        }, 100); // 减少延迟时间
      }

      // 新增方法：滚动到显示下拉框
      scrollToShowDropdown() {
        // 根据屏幕尺寸选择不同的滚动容器
        let scrollContainer;

        if (window.innerWidth <= 576) {
          // 移动端：使用水平滚动的容器
          scrollContainer = this.parentComponent.querySelector(
            '.ro-product-content-recommend-product-list__content_item_list'
          );
        } else {
          // 桌面端：使用垂直滚动的容器
          scrollContainer = this.parentComponent.querySelector('.ro-product-content-recommend-product-list__content');
        }

        if (!scrollContainer) return;

        const dropdownRect = this.dropdown.getBoundingClientRect();
        const containerRect = scrollContainer.getBoundingClientRect();

        // 检查下拉框底部是否超出容器底部（上下滚动）
        if (dropdownRect.bottom > containerRect.bottom) {
          const scrollDistance = dropdownRect.bottom - containerRect.bottom + 20;
          scrollContainer.scrollBy({
            top: scrollDistance,
            behavior: 'smooth',
          });
        }
      }

      closeDropdown() {
        this.isOpen = false;
        this.dropdown.classList.remove('open');
        this.chevron.classList.remove('open');
        this.selectButton.setAttribute('aria-expanded', 'false');
      }

      selectOption(option) {
        // 移除之前的选中状态
        this.options.forEach((opt) => opt.classList.remove('selected'));

        // 设置新的选中状态
        option.classList.add('selected');
        this.selectedOption = option;
        this.selectedText.textContent = option.textContent.trim();

        // TODO: 处理选择器变化逻辑
        // 1. 更新产品图片
        // 2. 更新产品价格
        // 3. 更新总价格
        // 4. 更新购物车数据
        this.handleOptionChange(option);

        this.closeDropdown();
      }

      // 处理选项变化
      handleOptionChange(option) {
        const productId = option.dataset.productId;
        const variantId = option.dataset.variantId;
        const price = option.dataset.price;
        const compareAtPrice = option.dataset.compareAtPrice;
        const image = option.dataset.image;

        // TODO: 根据选择器索引更新对应的产品信息
        // 如果是当前产品选择器 (index === 0)
        if (this.index === 0) {
          // 更新当前产品信息
          this.updateCurrentProduct(productId, variantId, price, compareAtPrice, image);
        } else {
          // 更新推荐产品信息
          this.updateRecommendProduct(this.index - 1, productId, variantId, price, compareAtPrice, image);
        }

        // TODO: 重新计算总价格
        const parentComponent = document.querySelector('ro-product-content-recommend-product-list');
        if (parentComponent) {
          parentComponent.updateTotalPrice();
        }
      }

      // 更新当前产品信息
      updateCurrentProduct(productId, variantId, price, compareAtPrice, image) {
        // TODO: 实现当前产品信息更新逻辑
        const parentComponent = document.querySelector('ro-product-content-recommend-product-list');
        const formatMoney = document.querySelector('ro-product-content-recommend-product').dataset.formatMoney;
        if (parentComponent) {
          parentComponent.setAttribute('data-current-variant', variantId);
          parentComponent.setAttribute('data-current-price', price);
          parentComponent.setAttribute('data-current-compare-at-price', compareAtPrice);
        }
        const currentProduct = parentComponent.querySelector(
          '.ro-product-content-recommend-product-list__content_current_product'
        );
        // 更新当前产品信息
        if (currentProduct) {
          currentProduct.querySelector(
            '.ro-product-content-recommend-product-list__content_current_product_image img'
          ).src = image;
          currentProduct.querySelector(
            '.ro-product-content-recommend-product-list__content_current_product_price_new'
          ).innerHTML = Shopify.formatMoney(price, formatMoney);
          currentProduct.querySelector(
            '.ro-product-content-recommend-product-list__content_current_product_price_old'
          ).innerHTML = Shopify.formatMoney(compareAtPrice, formatMoney);
          if (compareAtPrice > price) {
            currentProduct
              .querySelector('.ro-product-content-recommend-product-list__content_current_product_price_old')
              .classList.remove('hidden');
          } else {
            currentProduct
              .querySelector('.ro-product-content-recommend-product-list__content_current_product_price_old')
              .classList.add('hidden');
          }
        }
        // 将选中的变体更新到ro-product-sticky-form中
        const stickyForm = document.querySelector('ro-product-sticky-form');
        if (stickyForm) {
          stickyForm.setAttribute('data-current-variant-id', variantId);
        }
      }

      // 更新推荐产品信息
      updateRecommendProduct(productIndex, productId, variantId, price, compareAtPrice, image) {
        // TODO: 实现推荐产品信息更新逻辑
        const parentComponent = document.querySelector('ro-product-content-recommend-product-list');
        const formatMoney = document.querySelector('ro-product-content-recommend-product').dataset.formatMoney;
        const otherVariants = JSON.parse(parentComponent.getAttribute('data-other-variants'));
        if (parentComponent) {
          otherVariants.forEach((item) => {
            if (item.productId === productId) {
              item.variantId = variantId;
              item.price = price;
              item.compareAtPrice = compareAtPrice;
            }
          });
          parentComponent.setAttribute('data-other-variants', JSON.stringify(otherVariants));
        }
        const recommendProduct = parentComponent.querySelector(
          `.ro-product-content-recommend-product-list__content_item:nth-child(${productIndex + 1})`
        );
        // 更新数据
        if (recommendProduct) {
          recommendProduct.querySelector('.ro-product-content-recommend-product-list__content_item_image img').src =
            image;
          recommendProduct.querySelector(
            '.ro-product-content-recommend-product-list__content_item_price_new'
          ).innerHTML = Shopify.formatMoney(price, formatMoney);
          recommendProduct.querySelector(
            '.ro-product-content-recommend-product-list__content_item_price_old'
          ).innerHTML = Shopify.formatMoney(compareAtPrice, formatMoney);
          if (compareAtPrice > price) {
            recommendProduct
              .querySelector('.ro-product-content-recommend-product-list__content_item_price_old')
              .classList.remove('hidden');
          } else {
            recommendProduct
              .querySelector('.ro-product-content-recommend-product-list__content_item_price_old')
              .classList.add('hidden');
          }
          // 更新checkbox
          const checkbox = recommendProduct.querySelector(
            `.ro-product-content-recommend-product-list__content_item_checkbox[data-product-id="${productId}"]`
          );
          if (checkbox) {
            checkbox.setAttribute('data-variant-id', variantId);
            checkbox.setAttribute('data-price', price);
            checkbox.setAttribute('data-compare-at-price', compareAtPrice);
          }
          const addToCart = recommendProduct.querySelector(
            '.ro-product-content-recommend-product-list__content_item_add_to_cart'
          );
          if (addToCart) {
            addToCart.setAttribute('data-variant-id', variantId);
          }
        }
      }

      // 关闭其他所有选择器
      closeOtherSelectors() {
        if (this.parentComponent && this.parentComponent.selectors) {
          this.parentComponent.selectors.forEach((selector, selectorIndex) => {
            if (selectorIndex !== this.index && selector.isOpen) {
              selector.closeDropdown();
            }
          });
        }
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-product-content-variant-select"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-product-content-variant-select')) {
      customElements.define(
        'ro-product-content-variant-select',
        class RoProductContentVariantSelect extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            this.contents = this.querySelectorAll('.ro-product-content-variant-select__item');
            this.init();
          }

          init() {
            this.bindEvents();
            this.initStock();
          }
          // 提供外部调用，更新当前产品选中变体
          updateSelectedVariant(variantId) {
            const content = this.querySelector(
              `.ro-product-content-variant-select__item[data-variant-id="${variantId}"]`
            );
            if (content) {
              content.click();
            }
          }

          bindEvents() {
            this.contents.forEach((content) => {
              content.addEventListener('click', () => {
                this.contents.forEach((item) => {
                  item.classList.remove('active');
                });
                content.classList.add('active');
                const variantId = content.dataset.variantId;
                const inventoryQuantity = content.dataset.inventoryQuantity;
                const inventoryPolicy = content.dataset.inventoryPolicy;
                const imageUrl = content.dataset.imageUrl;
                const price = content.dataset.price;
                const compareAtPrice = content.dataset.compareAtPrice;
                const imagePosition = content.dataset.imagePosition;
                const stockout = content.dataset.stockout;
                const stock = this.querySelector('.ro-product-content-variant-select__item_stock');
                const productStickyForm = document.querySelector('ro-product-sticky-form');
                const info = document.querySelector('ro-product-content-product-info');
                const bottom = document.querySelector('ro-product-sticky-form-bottom');
                // 免税逻辑处理
                const isTax = content.dataset.isTax;
                console.log('isTax', isTax);
                console.log(
                  '12313',
                  productStickyForm.querySelectorAll('.ro-product-content-product-info__panel_btns_payment_button')
                );

                if (isTax == 'true') {
                  productStickyForm
                    .querySelectorAll('.ro-product-content-product-info__panel_btns_payment_button')
                    .forEach((item) => {
                      console.log('true', item);
                      item.setAttribute('data-tax-type', 'productDetail');
                    });
                } else {
                  productStickyForm
                    .querySelectorAll('.ro-product-content-product-info__panel_btns_payment_button')
                    .forEach((item) => {
                      console.log('false', item);
                      item.removeAttribute('data-tax-type');
                    });
                }
                if (info) {
                  info.dataset.stockout = stockout;
                  bottom.dataset.stockout = stockout;
                }
                // 大于0时显示物流信息
                if (inventoryQuantity > 0) {
                  productStickyForm.dataset.shipping = 'true';
                } else {
                  productStickyForm.dataset.shipping = 'false';
                }
                if (productStickyForm) {
                  let priceInfo = {
                    price: price,
                    compareAtPrice: compareAtPrice,
                  };
                  productStickyForm.dataset.priceInfo = JSON.stringify(priceInfo);
                  productStickyForm.dataset.currentImagePosition = imagePosition;
                  productStickyForm.dataset.inventoryQuantity = inventoryQuantity;
                  productStickyForm.dataset.inventoryPolicy = inventoryPolicy;
                  // 这个要保持在最后面，因为要先触发数量变化，再触发推荐产品变化，计算才会正常
                  productStickyForm.dataset.currentVariantId = variantId;
                  productStickyForm.dataset.currentImageUrl = imageUrl;
                }
                if (stock) {
                  stock.dataset.inventoryQuantity = inventoryQuantity;
                  stock.dataset.inventoryPolicy = inventoryPolicy;
                  this.initStock();
                }
                // 将变体id携带到当前路由中，不会刷新页面
                const url = new URL(window.location.href);
                url.searchParams.set('variant', variantId);
                window.history.pushState({}, '', url);
              });
            });
          }
          initStock() {
            const stock = this.querySelector('.ro-product-content-variant-select__item_stock');
            if (!stock) {
              return;
            }
            // 当前库存（data 为字符串，取实际数字）
            const inventoryQuantity = parseInt(stock.dataset.inventoryQuantity, 10);
            const inventoryPolicy = stock.dataset.inventoryPolicy;
            const globalProductMaxStock = parseInt(stock.dataset.globalProductMaxStock, 10);
            const globalProductMinStock = parseInt(stock.dataset.globalProductMinStock, 10);
            const unGlobalProductMinStock = parseInt(stock.dataset.unGlobalProductMinStock, 10);
            // 先更新库存数字（切换变体后必须立即更新，不受进度条逻辑影响）
            const textEl = stock.querySelector('.ro-product-content-variant-select__item_stock_content_text_number');
            if (textEl) {
              const showNum =
                inventoryQuantity < 0 || inventoryQuantity === 0 || isNaN(inventoryQuantity)
                  ? inventoryPolicy === 'continue'
                    ? globalProductMinStock
                    : unGlobalProductMinStock
                  : inventoryQuantity;
              textEl.textContent = typeof showNum === 'number' && !isNaN(showNum) ? showNum : '';
            }
            // 进度条
            const progressBar = stock.querySelector('.ro-product-content-variant-select__item_stock_progress_bar');
            if (!progressBar) {
              return;
            }
            if (isNaN(globalProductMaxStock) || globalProductMaxStock <= 0) {
              progressBar.style.width = '0%';
              return;
            }
            // 进度条取值：库存为负数或 0 时用对应最小阈值，否则用实际库存
            let barValue;
            if (inventoryPolicy === 'continue') {
              barValue = inventoryQuantity <= 0 || isNaN(inventoryQuantity) ? globalProductMinStock : inventoryQuantity;
            } else {
              barValue = Math.max(inventoryQuantity, unGlobalProductMinStock);
            }
            if (isNaN(barValue) || barValue < 0) {
              progressBar.style.width = '0%';
              return;
            }
            barValue = Math.min(barValue, globalProductMaxStock);
            progressBar.style.width = `${(barValue / globalProductMaxStock) * 100}%`;
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-product-left"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('ro-product-left')) {
      customElements.define(
        'ro-product-left',
        class RoProductLeft extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            window.starryEventBus.on('roInitStarrySwiper', () => {
              this.imageInit();
              this.videoInit();
              this.packageInit();
            });
            this.initTabHandle();
          }
          // 提供外部方法进行切换
          switchTab(position) {
            const imageTabDom = this.querySelector('.ro-product-left__tab_handle[data-tab="image"]');
            if (imageTabDom) {
              imageTabDom.click();
            }
            const swiperImageDom = this.querySelector('.ro-product-left__swiper_image');
            const slideIndex =
              swiperImageDom
                .querySelector(`.swiper-slide[data-position="${position}"]`)
                .getAttribute('data-swiper-slide-index') || 0;
            if (slideIndex) {
              swiperImageDom.swiper.slideToLoop(slideIndex);
            }
          }
          imageInit() {
            const swiperTabLeftHandleDom = this.querySelector('.ro-product-left__tab_left_handle_swiper');
            const swiperTabLeftHandleIconWrapperNextDom = this.querySelector(
              '.ro-product-left__tab_left_handle_icon_wrapper_next'
            );
            const swiperTabLeftHandleIconWrapperPrevDom = this.querySelector(
              '.ro-product-left__tab_left_handle_icon_wrapper_prev'
            );
            const swiperTabLeftHandle = new Swiper(swiperTabLeftHandleDom, {
              slidesPerView: 'auto',
              spaceBetween: 8,
            });
            swiperTabLeftHandleIconWrapperNextDom.addEventListener('click', () => {
              swiper.slideNext();
            });
            swiperTabLeftHandleIconWrapperPrevDom.addEventListener('click', () => {
              swiper.slidePrev();
            });
            const swiperDom = this.querySelector('.ro-product-left__swiper_image');
            const swiperButtonNextDom = this.querySelector('.ro-product-left__swiper_image_button_next');
            const swiperButtonPrevDom = this.querySelector('.ro-product-left__swiper_image_button_prev');
            const swiperPaginationDom = this.querySelector('.ro-product-left__swiper_image_pagination');
            const swiper = new Swiper(swiperDom, {
              slidesPerView: 1,
              spaceBetween: 48,
              loop: true,
              thumbs: {
                swiper: swiperTabLeftHandleDom,
              },
              navigation: {
                nextEl: swiperButtonNextDom,
                prevEl: swiperButtonPrevDom,
              },
              pagination: {
                el: swiperPaginationDom,
                type: 'fraction',
                renderFraction: function (currentClass, totalClass) {
                  return (
                    '<div class="ro-product-left__swiper_pagination_text"> <div class="ro-product-left__swiper_pagination_text_item">' +
                    '<span class="' +
                    currentClass +
                    '"></span>' +
                    ' / ' +
                    '<span class="' +
                    totalClass +
                    '"></span>' +
                    '</div></div>'
                  );
                },
              },
            });

            swiperDom.addEventListener('click', (e) => {
              const clickedImage = e.target.closest('.swiper-slide img');
              const isNavigationClick = e.target.closest(
                '.swiper-button-next, .swiper-button-prev, .swiper-pagination'
              );

              if (clickedImage && !isNavigationClick) {
                const imageZoom = document.querySelector('product-image-zoom');
                if (!imageZoom) return;

                // 设置为非 package 模式
                imageZoom.setMode(false);
                let imagesArray = this.getImagesArray();
                // 设置图片数据并打开预览
                imageZoom.setImages(imagesArray);
                const currentIndex = swiper.realIndex;
                imageZoom.openPreview(currentIndex);
              }
            });
          }

          // 修改 getImagesArray 方法，添加更多错误处理和日志
          getImagesArray() {
            this.$productMedia = document.querySelector('product-image-zoom .product-media');
            if (!this.$productMedia) {
              console.warn('productMedia element not found');
              return [];
            }

            try {
              const mediaJson = JSON.parse(this.$productMedia.textContent || this.$productMedia.innerHTML);

              if (!Array.isArray(mediaJson)) {
                console.warn('mediaJson is not an array:', mediaJson);
                return [];
              }

              const formattedImages = mediaJson
                .filter((media) => {
                  if (!media || !media.media_type) {
                    console.warn('Invalid media item:', media);
                    return false;
                  }
                  return media.media_type === 'image';
                })
                .map((media, index) => {
                  if (!media.preview_image || !media.preview_image.src) {
                    console.warn('Invalid preview image:', media);
                    return null;
                  }
                  return {
                    [`${index + 1}.img`]: media.preview_image.src,
                  };
                })
                .filter(Boolean); // 移除任何 null 值

              return formattedImages;
            } catch (error) {
              console.error('Error parsing media JSON:', error);
              return [];
            }
          }
          initTabHandle() {
            const tabHandleDom = this.querySelectorAll('.ro-product-left__tab_handle');
            const tabContentDom = this.querySelectorAll('.ro-product-left__tab_content');
            tabHandleDom.forEach((item) => {
              item.addEventListener('click', () => {
                if (!item.classList.contains('active')) {
                  tabHandleDom.forEach((item) => {
                    item.classList.remove('active');
                  });
                  tabContentDom.forEach((item) => {
                    item.classList.remove('active');
                  });
                  const itemHandleDom = this.querySelectorAll(
                    `.ro-product-left__tab_handle[data-tab="${item.dataset.tab}"]`
                  );
                  itemHandleDom.forEach((item) => {
                    item.classList.add('active');
                  });
                  const contentDom = this.querySelector(
                    `.ro-product-left__tab_content[data-content="${item.dataset.tab}"]`
                  );
                  contentDom.classList.add('active');
                }
              });
            });
          }
          videoInit() {
            const swiperDom = this.querySelector('.ro-product-left__swiper_video');
            if (!swiperDom) return;
            const swiperButtonNextDom = this.querySelector('.ro-product-left__swiper_video_button_next');
            const swiperButtonPrevDom = this.querySelector('.ro-product-left__swiper_video_button_prev');
            const swiperPaginationDom = this.querySelector('.ro-product-left__swiper_video_pagination');
            const swiper = new Swiper(swiperDom, {
              slidesPerView: 1,
              spaceBetween: 48,
              loop: true,
              navigation: {
                nextEl: swiperButtonNextDom,
                prevEl: swiperButtonPrevDom,
              },
              pagination: {
                el: swiperPaginationDom,
                type: 'fraction',
                renderFraction: function (currentClass, totalClass) {
                  return (
                    '<div class="ro-product-left__swiper_pagination_text"> <div class="ro-product-left__swiper_pagination_text_item">' +
                    '<span class="' +
                    currentClass +
                    '"></span>' +
                    ' / ' +
                    '<span class="' +
                    totalClass +
                    '"></span>' +
                    '</div></div>'
                  );
                },
              },
            });
          }
          packageInit() {
            const swiperDom = this.querySelector('.ro-product-left__swiper_package');
            if (!swiperDom) return;
            const swiperButtonNextDom = this.querySelector('.ro-product-left__swiper_package_button_next');
            const swiperButtonPrevDom = this.querySelector('.ro-product-left__swiper_package_button_prev');
            const swiperPaginationDom = this.querySelector('.ro-product-left__swiper_package_pagination');
            const swiper = new Swiper(swiperDom, {
              slidesPerView: 1,
              spaceBetween: 48,
              loop: true,
              navigation: {
                nextEl: swiperButtonNextDom,
                prevEl: swiperButtonPrevDom,
              },
              pagination: {
                el: swiperPaginationDom,
                type: 'fraction',
                renderFraction: function (currentClass, totalClass) {
                  return (
                    '<div class="ro-product-left__swiper_pagination_text"> <div class="ro-product-left__swiper_pagination_text_item">' +
                    '<span class="' +
                    currentClass +
                    '"></span>' +
                    ' / ' +
                    '<span class="' +
                    totalClass +
                    '"></span>' +
                    '</div></div>'
                  );
                },
              },
            });
            swiperDom.addEventListener('click', (e) => {
              const clickedImage = e.target.closest('.swiper-slide img');
              const isNavigationClick = e.target.closest(
                '.swiper-button-next, .swiper-button-prev, .swiper-pagination'
              );

              if (clickedImage && !isNavigationClick) {
                const imageZoom = document.querySelector('product-image-zoom');
                if (!imageZoom) return;

                // 首先尝试获取 package-media 数据
                const packageMedia = imageZoom.querySelector('.package-media');
                if (packageMedia && packageMedia.textContent) {
                  try {
                    const packageData = JSON.parse(packageMedia.textContent);
                    if (packageData && Object.keys(packageData).length > 0) {
                      // 设置为 package 模式
                      imageZoom.setMode(true);

                      const formattedPackageData = Object.entries(packageData).map(([index, url]) => ({
                        [`${parseInt(index) + 1}.img`]: url.startsWith('//') ? `https:${url}` : url,
                      }));
                      imageZoom.setImages(formattedPackageData);
                      const currentIndex = swiper.realIndex;
                      imageZoom.openPreview(currentIndex);
                      return;
                    }
                  } catch (error) {
                    console.error('Error parsing package media data:', error);
                  }
                }
              }
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-product-sticky-form-bottom"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-product-sticky-form-bottom')) {
      customElements.define(
        'ro-product-sticky-form-bottom',
        class RoProductStickyFormBottom extends HTMLElement {
          constructor() {
            super();
            this.countdownInterval = null;
            this.timeRemaining = 0;
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initCountdown();
            this.addAddToCartEvent();
            this.addNotifyMeEvent();
            this.initPanelObserver();
          }
          // 提供给外部调用，更新图片
          updateImageUrl(imageUrl) {
            this.querySelector('.ro-product-sticky-form-bottom__content_left_product_image').src = imageUrl;
          }
          // 提供给外部调用，更新价格和折扣信息
          updatePriceInfo(priceInfo, quantity) {
            const currentPrice = Number(priceInfo.price);
            const currentCompareAtPrice = Number(priceInfo.compareAtPrice);
            // 更新价格
            this.querySelector('.ro-product-sticky-form-bottom__content_left_price_new').innerHTML =
              Shopify.formatMoney(currentPrice * quantity, this.dataset.formatMoney);
            this.querySelector('.ro-product-sticky-form-bottom__content_left_price_old').innerHTML =
              Shopify.formatMoney(currentCompareAtPrice * quantity, this.dataset.formatMoney);
            if (currentCompareAtPrice && currentCompareAtPrice > currentPrice) {
              this.querySelector('.ro-product-sticky-form-bottom__content_left_price_old').classList.remove('hidden');
            } else {
              this.querySelector('.ro-product-sticky-form-bottom__content_left_price_old').classList.add('hidden');
            }
          }
          addNotifyMeEvent() {
            const notifyMe = this.querySelector('.ro-product-sticky-form-bottom__content_right_button_notify_me');
            notifyMe.addEventListener('click', () => {
              const notifyModal = document.querySelector('global-stock-notify-modal');
              const stickyForm = document.querySelector('ro-product-sticky-form');
              const variantId = stickyForm.dataset.currentVariantId;
              if (variantId && notifyModal) {
                notifyModal.open(variantId);
              }
            });
          }

          initPanelObserver() {
            const panel = document.querySelector('.ro-product-content-product-info__panel');
            const stickyBottom = this.querySelector('.ro-product-sticky-form-bottom');
            if (!panel || !stickyBottom) return;

            const observer = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    stickyBottom.classList.add('hidden');
                  } else {
                    stickyBottom.classList.remove('hidden');
                  }
                });
              },
              {
                threshold: 0,
                rootMargin: '0px 0px -1px 0px',
              }
            );

            observer.observe(panel);
          }

          addAddToCartEvent() {
            const addToCart = this.querySelector('.ro-product-sticky-form-bottom__content_right_button_add_to_cart');
            addToCart.addEventListener('click', async () => {
              const stickyForm = document.querySelector('ro-product-sticky-form');
              const currentNum = stickyForm.dataset.quantity;
              const variantId = stickyForm.dataset.currentVariantId;

              addToCart.setAttribute('data-loading', 'true');

              try {
                const response = await window.redodo.addCart([{ id: variantId, quantity: currentNum }]);
              } catch (error) {
                console.error('Error:', error);
              } finally {
                addToCart.setAttribute('data-loading', 'false');
              }
            });
          }
          initCountdown() {
            this.countdownElement = this.querySelector('.ro-product-sticky-form-bottom__content_left_countdown');
            if (!this.countdownElement) return;

            const startTsStr = this.countdownElement.getAttribute('data-start');
            const endTsStr = this.countdownElement.getAttribute('data-end');

            if (!endTsStr || endTsStr === '') return;

            const startTime = startTsStr !== '' ? parseInt(startTsStr, 10) * 1000 : null;
            const endTime = parseInt(endTsStr, 10) * 1000;
            if (Number.isNaN(endTime)) return;

            const now = Date.now();

            if (now > endTime) {
              this.countdownElement.style.display = 'none';
              return;
            }

            const hasStart = startTime !== null && !Number.isNaN(startTime);

            if (hasStart && now < startTime) {
              this.countdownElement.style.display = 'none';
            } else {
              this.timeRemaining = endTime - now;
              this.countdownElement.style.display = 'flex';
              this.renderStickyCountdown(this.timeRemaining);
            }

            this.countdownInterval = setInterval(() => this.tickStickyCountdown(), 1000);
          }
          disconnectedCallback() {
            if (this.countdownInterval) {
              clearInterval(this.countdownInterval);
            }
          }
          tickStickyCountdown() {
            if (!this.countdownElement) return;

            const endTsStr = this.countdownElement.getAttribute('data-end');
            const startTsStr = this.countdownElement.getAttribute('data-start');

            const now = Date.now();
            const startTime = startTsStr ? parseInt(startTsStr, 10) * 1000 : null;
            const endTime = parseInt(endTsStr, 10) * 1000;

            if (Number.isNaN(endTime)) {
              this.countdownElement.style.display = 'none';
              clearInterval(this.countdownInterval);
              return;
            }

            if (now > endTime) {
              this.timeRemaining = 0;
              this.renderStickyCountdown(0);
              this.countdownElement.style.display = 'none';
              clearInterval(this.countdownInterval);
              return;
            }

            const hasStart = startTime !== null && !Number.isNaN(startTime);
            if (hasStart && now < startTime) {
              this.countdownElement.style.display = 'none';
              return;
            }

            this.timeRemaining = endTime - now;
            this.countdownElement.style.display = 'flex';
            this.renderStickyCountdown(this.timeRemaining);
          }
          renderStickyCountdown(diff) {
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            const daysElement = this.countdownElement.querySelector('.days');
            const hoursElement = this.countdownElement.querySelector('.hrs');
            const minutesElement = this.countdownElement.querySelector('.min');
            const secondsElement = this.countdownElement.querySelector('.sec');

            if (daysElement) daysElement.textContent = days.toString().padStart(2, '0');
            if (hoursElement) hoursElement.textContent = hours.toString().padStart(2, '0');
            if (minutesElement) minutesElement.textContent = minutes.toString().padStart(2, '0');
            if (secondsElement) secondsElement.textContent = seconds.toString().padStart(2, '0');
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-product-support-download"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-product-support-download')) {
      customElements.define(
        'ro-product-support-download',
        class RoProductSupportDownload extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initDownloadButtons();
          }

          /**
           * 初始化下载按钮功能
           */
          initDownloadButtons() {
            const downloadBtns = this.querySelectorAll('.ro-product-support-download_item_download');

            downloadBtns.forEach((btn) => {
              btn.addEventListener('click', (e) => {
                e.stopPropagation(); // 防止触发父级事件

                const downloadUrl = btn.getAttribute('data-download-url');
                if (downloadUrl) {
                  // 检测是否为 iOS Safari
                  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

                  if (isIOS) {
                    // iOS Safari 使用简单的下载方式
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.download = this.getCleanFilename(downloadUrl);
                    link.target = '_blank';
                    link.click();
                  } else {
                    // 其他浏览器使用 fetch 强制下载
                    fetch(downloadUrl)
                      .then((response) => response.blob())
                      .then((blob) => {
                        // 创建临时 URL
                        const blobUrl = window.URL.createObjectURL(blob);

                        // 创建下载链接
                        const link = document.createElement('a');
                        link.href = blobUrl;

                        // 提取干净的文件名
                        link.download = this.getCleanFilename(downloadUrl);

                        // 触发下载
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        // 清理临时 URL
                        window.URL.revokeObjectURL(blobUrl);
                      })
                      .catch((error) => {
                        console.error('下载失败:', error);
                        // 回退到简单的 a 标签下载
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        link.download = this.getCleanFilename(downloadUrl);
                        link.target = '_blank';
                        link.click();
                      });
                  }
                }
              });
            });
          }

          /**
           * 从 URL 中提取干净的文件名（去掉查询参数）
           */
          getCleanFilename(url) {
            return (url.split('/').pop() || 'download').replace(/\?.*$/, '');
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-product-support-faq"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-product-support-faq')) {
      customElements.define(
        'ro-product-support-faq',
        class RoProductSupportFaq extends HTMLElement {
          constructor() {
            super();
            this.handleResize = this.handleResize.bind(this);
            this.bindEvents();
          }

          bindEvents() {
            window.addEventListener('resize', this.handleResize);
            this.addEventListener('click', (e) => {
              if (e.target.closest('.faq-trigger')) {
                this.toggleFAQ(e);
              }
            });
          }

          disconnectedCallback() {
            window.removeEventListener('resize', this.handleResize);
          }

          toggleFAQ(event) {
            const trigger = event.target.closest('.faq-trigger');
            const item = trigger.closest('.faq-item');
            const answer = trigger.nextElementSibling;
            const content = answer.children[0];

            // 关闭其他所有打开的FAQ
            this.querySelectorAll('.faq-answer').forEach((el) => {
              if (el !== answer) {
                el.style.height = '0';
              }
            });

            this.querySelectorAll('.faq-item').forEach((el) => {
              if (el !== item) {
                el.classList.remove('active');
              }
            });

            // 切换当前FAQ的状态
            if (parseInt(answer.style.height) > 0) {
              answer.style.height = '0';
              item.classList.remove('active');
            } else {
              const height = content.offsetHeight;
              answer.style.height = height + 'px';
              item.classList.add('active');
            }
          }

          handleResize() {
            const openAnswers = Array.from(this.querySelectorAll('.faq-answer')).filter(
              (answer) => parseInt(answer.style.height) > 0
            );

            if (openAnswers.length) {
              openAnswers.forEach((answer) => {
                const height = answer.children[0].offsetHeight;
                answer.style.height = height + 'px';
              });
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ro-product-support-video"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('ro-product-support-video')) {
      customElements.define(
        'ro-product-support-video',
        class RoProductSupportVideo extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            this.init();
          }

          init() {
            this.initPagination();
          }

          initPagination() {
            const pagination = this.querySelector('.ro-product-support-video_pagination');
            const paginationButtonLeft = this.querySelector('.ro-product-support-video_pagination_left');
            const paginationButtonRight = this.querySelector('.ro-product-support-video_pagination_right');
            const paginationCenterText = this.querySelectorAll('.ro-product-support-video_pagination_center_text');
            paginationButtonLeft.addEventListener('click', () => {
              const currentPage = Number(this.dataset.currentPage);
              this.setCurrentPage(currentPage - 1);
            });
            paginationButtonRight.addEventListener('click', () => {
              const currentPage = Number(this.dataset.currentPage);
              this.setCurrentPage(currentPage + 1);
            });
            paginationCenterText.forEach((item) => {
              item.addEventListener('click', () => {
                this.setCurrentPage(Number(item.dataset.page));
              });
            });
          }
          setCurrentPage(page) {
            const totalPages = Number(this.dataset.totalPages);
            if (page < 1) {
              page = 1;
            }
            if (page > totalPages) {
              page = totalPages;
            }
            if (page === Number(this.dataset.currentPage)) {
              return;
            }
            this.dataset.currentPage = page;
            this.switchPage(page);
          }
          switchPage(page) {
            const totalPages = Number(this.dataset.totalPages);
            const paginationButtonLeft = this.querySelector('.ro-product-support-video_pagination_left');
            const paginationButtonRight = this.querySelector('.ro-product-support-video_pagination_right');
            const paginationCenterText = this.querySelectorAll('.ro-product-support-video_pagination_center_text');
            // 如果page == totalPages 则给paginationButtonRight 添加disabled
            if (page == totalPages) {
              paginationButtonRight.classList.add('disabled');
            } else {
              paginationButtonRight.classList.remove('disabled');
            }
            // 如果page == 1 则给paginationButtonLeft 添加disabled
            if (page == 1) {
              paginationButtonLeft.classList.add('disabled');
            } else {
              paginationButtonLeft.classList.remove('disabled');
            }
            // 给paginationCenterText 添加active
            paginationCenterText.forEach((item) => {
              item.classList.remove('active');
            });
            const textDom = this.querySelector(`.ro-product-support-video_pagination_center_text[data-page="${page}"]`);
            textDom.classList.add('active');
            // 根据page 显示对应的数据
            const itemDom = this.querySelectorAll(`.ro-product-support-video_item`);
            itemDom.forEach((item) => {
              item.classList.remove('active');
            });
            const pageDom = this.querySelectorAll(`.ro-product-support-video_item[data-page="${page}"]`);
            pageDom.forEach((item) => {
              item.classList.add('active');
            });
            // 由于每次切换都会导致页面变化，希望能够滚动到this的顶部，来让用户看到下一页的第一个
            // 由于有导航栏，需要偏移100px
            const rect = this.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const targetTop = scrollTop + rect.top - 100;
            window.scrollTo({
              top: targetTop,
              behavior: 'instant',
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["select-filter-colletion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('select-href')) {
      customElements.define(
        'select-href',
        class selectHref extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            let selectDom = this.querySelector('.select_href_main');
            selectDom.addEventListener('click', (event) => {
              this.compareDropdownTrigger(event);
            });
            document.addEventListener('click', (e) => {
              this.cleanAllDropdownSelect(e);
            });
          }
          compareDropdownTrigger(event) {
            event.stopPropagation();
            let selectDom = this.querySelector('.select_href_main');
            let visibleValue = selectDom.getAttribute('data-visible');
            // 如果当前值是 'false'，则修改为 'true'，否则修改为 'false'
            let newVisibleValue = visibleValue === 'false' ? 'true' : 'false';
            selectDom.setAttribute('data-visible', newVisibleValue);
          }
          cleanAllDropdownSelect(e) {
            let className = e.target.className;
            if (className === 'select_href_options') {
              return;
            }
            let selectDom = this.querySelector('.select_href_main');
            if (selectDom.getAttribute('data-visible') === 'true') {
              selectDom.setAttribute('data-visible', 'false');
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

})();
